//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// Settings - Customer Settings
//              Version 1.042 - February 17, 2023
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import React, { } from 'react';
import { withRouter } from './withRouter';
import { Buffer } from 'buffer';
import { SessionInfo } from './App';
import { Popup } from '@progress/kendo-react-popup';
import { ListView, ListViewHeader, ListViewFooter } from '@progress/kendo-react-listview';
import { TabStrip, TabStripTab, Splitter } from '@progress/kendo-react-layout';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { ColorPicker,ColorPickerChangeEvent } from "@progress/kendo-react-inputs";
import { Switch } from "@progress/kendo-react-inputs";
import { ExternalDropZone,Upload } from "@progress/kendo-react-upload";
import { Button } from '@progress/kendo-react-buttons';
import { Avatar } from '@progress/kendo-react-layout';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { FloatingLabel } from '@progress/kendo-react-labels'
import { Input } from '@progress/kendo-react-inputs';
import { Iframe } from './CommonControls.js';
import { ReactComponent as ButtonAddRow } from "./images/button-add-row.svg";
import { ReactComponent as ButtonSearch } from "./images/search.svg";
import { ReactComponent as ButtonClear } from "./images/button-clear.svg";

import PageHeader from './PageHeader.js';
import PageFooter from './PageFooter.js';
import PageSide from './PageSide.js';
import { CallOM,OMTrace,GetTableDataRaw,GetTableSearch,GetTableSearchRaw,UpdateRow,DeleteRowTry,DeleteRowForce,GetFileExtension,displayMessage,displayError,displayNotify,getHelpTopics,getHelpDetail, GetDropdownData, GetDependentDropdownData, saveImageFileToServer, getDocumentType, getImageFileFromServer, displayWarning, LogOffResetMsg, LogOffReset, setCSSVariable, CTYP } from './CommonCode.js';
import { DaysOfWeekFixedValues,FontTypeValues,FontSizeValues,FontWhtValues, SetTimeOverrideTypes, TimePickerCell, MoneyCell, BoolCell, cellDateTime, cellCurrencyAmt, SetProductItemCategory, ProductItemCategoryDropDownCell, SetProductItemGroup, ProductItemGroupDropDownCell, SetProductType, ProductTypeDropDownCell, SetLocations, SetPricingType, SublocationTypesDropDownCell, LocationDropDownCell, SetSublocationTypes, EditGridCommandCell } from './CommonFormat.js';

import { ReactComponent as HelpAbout } from "./images/help-about.svg";

//------ Object Definition For Companies -- Date: 2023-09-01-10:13 AM ------
const CompaniesOID = 488610;
const CompaniesO = [{ n: 'CompanyID',t: 195,p: 100 },{ n: 'CompanyName',t: 21,p: 0 },{ n: 'CompanyCode',t: 21,p: 0 },{ n: 'CompanyDBA',t: 21,p: 0 },{ n: 'CompanyLegalName',t: 21,p: 0 },{ n: 'BrandName',t: 21,p: 0 },{ n: 'AccountNumber',t: 21,p: 0 },{ n: 'AccountStartDate',t: 34,p: 0 },{ n: 'CompanyTypeID',t: 15,p: 0 },{ n: 'CompanyStatusID',t: 195,p: 100 },{ n: 'ParentCompanyID',t: 195,p: 100 },{ n: 'MainBusinessPhone',t: 21,p: 0 },{ n: 'MainEmailAddress',t: 21,p: 0 },{ n: 'ContactSet',t: 42,p: 0 },{ n: 'PrimeContactName',t: 21,p: 0 },{ n: 'FaxNumber',t: 21,p: 0 },{ n: 'TollFreeNumber',t: 21,p: 0 },{ n: 'MainCellNumber',t: 21,p: 0 },{ n: 'AlternatePhoneNumber',t: 21,p: 0 },{ n: 'WebSite',t: 21,p: 0 },{ n: 'TAXNumber',t: 21,p: 0 },{ n: 'TAX2Number',t: 21,p: 0 },{ n: 'DUNSNumber',t: 21,p: 0 },{ n: 'UnitNumber',t: 21,p: 0 },{ n: 'Address',t: 21,p: 0 },{ n: 'City',t: 21,p: 0 },{ n: 'ProvinceStateID',t: 195,p: 100 },{ n: 'PostalCode',t: 21,p: 0 },{ n: 'CountryID',t: 195,p: 100 },{ n: 'SalesGroupID',t: 195,p: 100 },{ n: 'SalesPersonID',t: 195,p: 100 },{ n: 'InvoiceGroupID',t: 195,p: 100 },{ n: 'MonthPeriodType',t: 201,p: 0 },{ n: 'CurrentMonthEnd',t: 34,p: 0 },{ n: 'CompanyLogo',t: 41,p: 0 },{ n: 'CompanyImage',t: 41,p: 0 },{ n: 'CompanyUserName',t: 21,p: 0 },{ n: 'Description',t: 21,p: 0 },{ n: 'Comments',t: 21,p: 0 },{ n: 'IsRecordActive',t: 22,p: 0 },{ n: 'ControlFlags',t: 27,p: 0 },{ n: 'CreatedBy',t: 195,p: 100 },{ n: 'CreatedOn',t: 35,p: 0 },{ n: 'LastModifiedBy',t: 195,p: 100 },{ n: 'LastModifiedOn',t: 35,p: 0 },{ n: 'AppEntityID',t: 195,p: 100 },{ n: 'AppGroupID',t: 195,p: 100 }];
//       Object Value Definition For Companies
const CV = { 'CompanyID': 0,'CompanyName': '','CompanyCode': '','CompanyDBA': '','CompanyLegalName': '','BrandName': '','AccountNumber': '','AccountStartDate': new Date(),'CompanyTypeID': 0,'CompanyStatusID': 0,'ParentCompanyID': 0,'MainBusinessPhone': '','MainEmailAddress': '','ContactSet': '','PrimeContactName': '','FaxNumber': '','TollFreeNumber': '','MainCellNumber': '','AlternatePhoneNumber': '','WebSite': '','TAXNumber': '','TAX2Number': '','DUNSNumber': '','UnitNumber': '','Address': '','City': '','ProvinceStateID': 0,'PostalCode': '','CountryID': 0,'SalesGroupID': 0,'SalesPersonID': 0,'InvoiceGroupID': 0,'MonthPeriodType': 0,'CurrentMonthEnd': new Date(),'CompanyLogo': '','CompanyImage': '','CompanyUserName': '','Description': '','Comments': '','IsRecordActive': false,'ControlFlags': 0,'CreatedBy': 0,'CreatedOn': new Date(),'LastModifiedBy': 0,'LastModifiedOn': new Date(),'AppEntityID': 0,'AppGroupID': 0 };
//       Object Index Definition For Companies
const CX = { 'CompanyID': 0,'CompanyName': 1,'CompanyCode': 2,'CompanyDBA': 3,'CompanyLegalName': 4,'BrandName': 5,'AccountNumber': 6,'AccountStartDate': 7,'CompanyTypeID': 8,'CompanyStatusID': 9,'ParentCompanyID': 10,'MainBusinessPhone': 11,'MainEmailAddress': 12,'ContactSet': 13,'PrimeContactName': 14,'FaxNumber': 15,'TollFreeNumber': 16,'MainCellNumber': 17,'AlternatePhoneNumber': 18,'WebSite': 19,'TAXNumber': 20,'TAX2Number': 21,'DUNSNumber': 22,'UnitNumber': 23,'Address': 24,'City': 25,'ProvinceStateID': 26,'PostalCode': 27,'CountryID': 28,'SalesGroupID': 29,'SalesPersonID': 30,'InvoiceGroupID': 31,'MonthPeriodType': 32,'CurrentMonthEnd': 33,'CompanyLogo': 34,'CompanyImage': 35,'CompanyUserName': 36,'Description': 37,'Comments': 38,'IsRecordActive': 39,'ControlFlags': 40,'CreatedBy': 41,'CreatedOn': 42,'LastModifiedBy': 43,'LastModifiedOn': 44,'AppEntityID': 45,'AppGroupID': 46 };

//------ Encoded Values - CompanyTypeID ------
const CompanyTypeIDFixedValues = [{ n: 'Account Owner',k: 6 },{ n: 'SKU Owner',k: 1 },{ n: 'Producer',k: 4 },{ n: 'Shipper',k: 5 },{ n: 'Supplier',k: 11 },{ n: 'Carrier',k: 8 },{ n: 'Consignee',k: 7 },{ n: 'Broker',k: 3 },{ n: 'Retailer',k: 2 },{ n: 'Regulatory',k: 12 },{ n: 'Other',k: 20 }];
//------ Encoded Entries - CompanyTypeID ------
const CompanyTypeIDList = ['Account Owner','SKU Owner','Producer','Shipper','Supplier','Carrier','Consignee','Broker','Retailer','Regulatory','Other'];

//------ Object Definition For CheckoutControls -- Date: 2023-09-01-10:10 AM ------
const CheckoutControlsOID = 546475;
const CheckoutControlsO = [{ n: 'CheckoutControlID',t: 195,p: 100 },{ n: 'CompanyID',t: 195,p: 100 },{ n: 'MaximumStoreCount',t: 24,p: 0 },{ n: 'HoldProblemDays',t: 24,p: 0 },{ n: 'HoldAbandonedDays',t: 24,p: 0 },{ n: 'CompanyAppEntityID',t: 24,p: 0 },{ n: 'MaxMonthsForReceipts',t: 24,p: 0 },{ n: 'MaximumProductCount',t: 24,p: 0 },{ n: 'MaximumUserCount',t: 24,p: 0 },{ n: 'InteractControls',t: 15,p: 0 }];
//       Object Value Definition For CheckoutControls
const CCV = { 'CheckoutControlID': 0,'CompanyID': 0,'MaximumStoreCount': 0,'HoldProblemDays': 0,'HoldAbandonedDays': 0,'CompanyAppEntityID': 0,'MaxMonthsForReceipts': 0,'MaximumProductCount': 0,'MaximumUserCount': 0,'InteractControls': 0 };
//       Object Index Definition For CheckoutControls
const CCX = { 'CheckoutControlID': 0,'CompanyID': 1,'MaximumStoreCount': 2,'HoldProblemDays': 3,'HoldAbandonedDays': 4,'CompanyAppEntityID': 5,'MaxMonthsForReceipts': 6,'MaximumProductCount': 7,'MaximumUserCount': 8,'InteractControls': 9 };
//------ Encoded Values - InteractControls ------
const InteractControlsFixedValues = [{ n: 'App Debug Mode',k: 1 },{ n: 'Time Of Day Control',k: 2 },{ n: 'Season Control',k: 3 },{ n: 'Day Of Week Control',k: 4 },{ n: 'Price Override Control',k: 5 }];
//------ Encoded Entries - InteractControls ------
const InteractControlsList = ['App Debug Mode','Time Of Day Control','Season Control','Day Of Week Control','Price Override Control'];//------ Encoded Values - InteractControls ------

//------ Object Definition For EntityConfiguration -- Date: 2024-06-06-9:05 AM ------
const EntityConfigurationOID = 546692;
const EntityConfigurationO = [{ n: 'EntityConfigurationID',t: 195,p: 100 },{ n: 'CompanyID',t: 195,p: 100 },{ n: 'StorePromotionID',t: 195,p: 100 },{ n: 'Promo1Link',t: 21,p: 0 },{ n: 'StorePromotion2',t: 195,p: 100 },{ n: 'Promo2Link',t: 21,p: 0 },{ n: 'StorePromotion3',t: 195,p: 100 },{ n: 'Promo3Link',t: 21,p: 0 },{ n: 'StorePromotion4',t: 195,p: 100 },{ n: 'Promo4Link',t: 21,p: 0 },{ n: 'GreetingMessage',t: 21,p: 0 },{ n: 'SecondMessage',t: 21,p: 0 },{ n: 'InputTextColor',t: 21,p: 0 },{ n: 'InputBGColor',t: 21,p: 0 },{ n: 'InputBorderColor',t: 21,p: 0 },{ n: 'InputFontType',t: 24,p: 0 },{ n: 'InputFontSize',t: 24,p: 0 },{ n: 'ButtonTextColor',t: 21,p: 0 },{ n: 'ButtonBGColor',t: 21,p: 0 },{ n: 'ButtonFontType',t: 24,p: 0 },{ n: 'ButtonFontSize',t: 24,p: 0 },{ n: 'HeadingTextColor',t: 21,p: 0 },{ n: 'HeadingFontType',t: 24,p: 0 },{ n: 'HeadingFontSize',t: 24,p: 0 },{ n: 'ItemNameColor',t: 21,p: 0 },{ n: 'ItemNameFontType',t: 24,p: 0 },{ n: 'ItemNameFontSize',t: 24,p: 0 },{ n: 'ItemNameFontWht',t: 24,p: 0 },{ n: 'ItemDescColor',t: 21,p: 0 },{ n: 'ItemDescFontType',t: 24,p: 0 },{ n: 'ItemDescFontSize',t: 24,p: 0 },{ n: 'ItemDescFontWht',t: 24,p: 0 },{ n: 'ListBGColor',t: 21,p: 0 },{ n: 'ListFontType',t: 24,p: 0 },{ n: 'ListFontSize',t: 24,p: 0 },{ n: 'ListHeadTextColor',t: 21,p: 0 },{ n: 'ListHeadBGColor',t: 21,p: 0 },{ n: 'HeadFontType',t: 24,p: 0 },{ n: 'HeadFontSize',t: 24,p: 0 },{ n: 'ListSectionTextColor',t: 21,p: 0 },{ n: 'ListSectionBGColor',t: 21,p: 0 },{ n: 'SectionFontType',t: 24,p: 0 },{ n: 'SectionFontSize',t: 24,p: 0 },{ n: 'PromptColor',t: 21,p: 0 },{ n: 'PromptFontType',t: 24,p: 0 },{ n: 'PromptFontSize',t: 24,p: 0 },{ n: 'PromoColor',t: 21,p: 0 },{ n: 'CartColor',t: 21,p: 0 },{ n: 'PurchasedColor',t: 21,p: 0 },{ n: 'BrandColor',t: 21,p: 0 },{ n: 'BrandLogo',t: 41,p: 0 },{ n: 'BackgroundImage',t: 41,p: 0 },{ n: 'DefaultStoreLocationID',t: 24,p: 0 },{ n: 'DefaultOrderType',t: 24,p: 0 },{ n: 'GeoFenceMeters',t: 24,p: 0 },{ n: 'RegistrationCode',t: 21,p: 0 },{ n: 'BaseDayOfWeek',t: 24,p: 0 },{ n: 'Tax1Percent',t: 16,p: 8 },{ n: 'Tax2Percent',t: 16,p: 8 },{ n: 'Tax3Percent',t: 16,p: 8 },{ n: 'ApplicationConfiguration',t: 15,p: 0 },{ n: 'LayoutConfiguration',t: 15,p: 0 },{ n: 'LastUpdatedOn',t: 35,p: 0 },{ n: 'ProcessCommand',t: 201,p: 0 },{ n: 'ApplicationTypeID',t: 195,p: 100 }];
//       Object Value Definition For EntityConfiguration
const ECV = { 'EntityConfigurationID': 0,'CompanyID': 0,'StorePromotionID': 0,'Promo1Link': '','StorePromotion2': 0,'Promo2Link': '','StorePromotion3': 0,'Promo3Link': '','StorePromotion4': 0,'Promo4Link': '','GreetingMessage': '','SecondMessage': '','InputTextColor': '','InputBGColor': '','InputBorderColor': '','InputFontType': 0,'InputFontSize': 0,'ButtonTextColor': '','ButtonBGColor': '','ButtonFontType': 0,'ButtonFontSize': 0,'HeadingTextColor': '','HeadingFontType': 0,'HeadingFontSize': 0,'ItemNameColor': '','ItemNameFontType': 0,'ItemNameFontSize': 0,'ItemNameFontWht': 0,'ItemDescColor': '','ItemDescFontType': 0,'ItemDescFontSize': 0,'ItemDescFontWht': 0,'ListBGColor': '','ListFontType': 0,'ListFontSize': 0,'ListHeadTextColor': '','ListHeadBGColor': '','HeadFontType': 0,'HeadFontSize': 0,'ListSectionTextColor': '','ListSectionBGColor': '','SectionFontType': 0,'SectionFontSize': 0,'PromptColor': '','PromptFontType': 0,'PromptFontSize': 0,'PromoColor': '','CartColor': '','PurchasedColor': '','BrandColor': '','BrandLogo': '','BackgroundImage': '','DefaultStoreLocationID': 0,'DefaultOrderType': 0,'GeoFenceMeters': 0,'RegistrationCode': '','BaseDayOfWeek': 0,'Tax1Percent': 0,'Tax2Percent': 0,'Tax3Percent': 0,'ApplicationConfiguration': 0,'LayoutConfiguration': 0,'LastUpdatedOn': new Date(),'ProcessCommand': 0,'ApplicationTypeID': 0 };
//       Object Index Definition For EntityConfiguration
const ECX = { 'EntityConfigurationID': 0,'CompanyID': 1,'StorePromotionID': 2,'Promo1Link': 3,'StorePromotion2': 4,'Promo2Link': 5,'StorePromotion3': 6,'Promo3Link': 7,'StorePromotion4': 8,'Promo4Link': 9,'GreetingMessage': 10,'SecondMessage': 11,'InputTextColor': 12,'InputBGColor': 13,'InputBorderColor': 14,'InputFontType': 15,'InputFontSize': 16,'ButtonTextColor': 17,'ButtonBGColor': 18,'ButtonFontType': 19,'ButtonFontSize': 20,'HeadingTextColor': 21,'HeadingFontType': 22,'HeadingFontSize': 23,'ItemNameColor': 24,'ItemNameFontType': 25,'ItemNameFontSize': 26,'ItemNameFontWht': 27,'ItemDescColor': 28,'ItemDescFontType': 29,'ItemDescFontSize': 30,'ItemDescFontWht': 31,'ListBGColor': 32,'ListFontType': 33,'ListFontSize': 34,'ListHeadTextColor': 35,'ListHeadBGColor': 36,'HeadFontType': 37,'HeadFontSize': 38,'ListSectionTextColor': 39,'ListSectionBGColor': 40,'SectionFontType': 41,'SectionFontSize': 42,'PromptColor': 43,'PromptFontType': 44,'PromptFontSize': 45,'PromoColor': 46,'CartColor': 47,'PurchasedColor': 48,'BrandColor': 49,'BrandLogo': 50,'BackgroundImage': 51,'DefaultStoreLocationID': 52,'DefaultOrderType': 53,'GeoFenceMeters': 54,'RegistrationCode': 55,'BaseDayOfWeek': 56,'Tax1Percent': 57,'Tax2Percent': 58,'Tax3Percent': 59,'ApplicationConfiguration': 60,'LayoutConfiguration': 61,'LastUpdatedOn': 62,'ProcessCommand': 63,'ApplicationTypeID': 64 };

//------ Encoded Values - ApplicationConfiguration ------
const ApplicationConfigurationFixedValues = [{ n: 'Scan And Pay',k: 1 },{ n: 'Order And Pay',k: 2 },{ n: 'Scan Pay Individual Items',k: 3 },{ n: 'Has Ingredients',k: 5 },{ n: 'Has Order To Table',k: 6 },{ n: 'Has Delivery',k: 7 },{ n: 'Has Tip',k: 4 },{ n: 'Has Item Lookup',k: 8 },{ n: 'Has Recipe Lookup',k: 9 },{ n: 'Has Store Promotion',k: 10 },{ n: 'Has Account Info',k: 11 },{ n: 'Has Gift Cards',k: 12 },{ n: 'Has Coupons',k: 13 },{ n: 'Has Shopping List',k: 14 },{ n: 'Category Page',k: 15 },{ n: 'Has Partial Payment',k: 16 },{ n: 'Has Seats',k: 17 },{ n: 'Has Guest Invite',k: 18 },{ n: 'Has Discounts',k: 19 },{ n: 'Has Credit',k: 20 },{ n: 'Has Returns',k: 22 },{ n: 'Has Tax1',k: 24 },{ n: 'Has Tax2',k: 25 },{ n: 'Has Tax3',k: 26 },{ n: 'Has Workflow',k: 27 },{ n: 'Has Cash Payment',k: 28 },{ n: 'Has Void Order',k: 29 },{ n: 'Has Void Item',k: 30 }];
//------ Encoded Entries - ApplicationConfiguration ------
const ApplicationConfigurationList = ['Scan And Pay','Order And Pay','Scan Pay Individual Items','Has Ingredients','Has Order To Table','Has Delivery','Has Tip','Has Item Lookup','Has Recipe Lookup','Has Store Promotion','Has Account Info','Has Gift Cards','Has Coupons','Has Shopping List','Category Page','Has Partial Payment','Has Seats','Has Guest Invite','Has Discounts','Has Credit','Has Returns','Has Tax1','Has Tax2','Has Tax3','Has Workflow','Has Cash Payment','Has Void Order','Has Void Item'];
//------ Encoded Values - LayoutConfiguration ------
const LayoutConfigurationFixedValues = [{ n: 'Has Landing Page',k: 1 },{ n: 'Has Location Info',k: 2 },{ n: 'Has Background Menu Image',k: 3 },{ n: 'Use Menu Layout 1',k: 4 },{ n: 'Use Menu Layout 2',k: 5 },{ n: 'Use Menu Layout 3',k: 6 },{ n: 'Use Menu Layout 4',k: 7 },{ n: 'Use Menu Layout 5',k: 8 },{ n: 'Use Menu Layout6',k: 9 },{ n: 'Use Menu Layout7',k: 10 },{ n: 'Use Menu Layout8',k: 11 },{ n: 'Has Group Menus',k: 15 },{ n: 'Retail Configuration',k: 16 },{ n: 'Drop Box Borders',k: 17 },{ n: 'Wide Spacing',k: 18 },{ n: 'Category Images',k: 19 },{ n: 'Option Images',k: 20 },{ n: 'Two Level Group',k: 21 }];
//------ Encoded Entries - LayoutConfiguration ------
const LayoutConfigurationList = ['Has Landing Page','Has Location Info','Has Background Menu Image','Use Menu Layout 1','Use Menu Layout 2','Use Menu Layout 3','Use Menu Layout 4','Use Menu Layout 5','Use Menu Layout6','Use Menu Layout7','Use Menu Layout8','Has Group Menus','Retail Configuration','Drop Box Borders','Wide Spacing','Category Images','Option Images','Two Level Group'];

const uploadCompanyRef = React.createRef();
const uploadBrandRef = React.createRef();
const uploadCompanyImageRef = React.createRef();
const uploadBGRef = React.createRef();
let currentImageID = 0;

class SettinsPage extends React.Component {
  constructor(props) {
    super(props);
    if (!SessionInfo.session)
      return;
    console.log("settings history: " + JSON.stringify(props.history));
    if (SessionInfo.CustomerID > 0) {
      console.log("Get Customer Desc for: " + SessionInfo.CustomerID);
      displayMessage("GREEN");
    }
    else {
      if (SessionInfo.SettingsPage) { // Data saved for this session
        //console.log("contractAccess: " + JSON.stringify(SessionInfo.contractAccess));
        this.state = SessionInfo.SettingsPage;
      }
    }
    SessionInfo.currSaveFunc = this.saveCompany;
    SessionInfo.currDeleteFunc = this.deleteDefault;
    SessionInfo.currClearFunc = this.clearDefault;
    SessionInfo.currAddGridRowFunc = undefined;
    SessionInfo.currExcelExportFunc = undefined;
    SessionInfo.currShowHelp = this.showHelp;
    SessionInfo.currExpandLPane = undefined;
    SessionInfo.currCollapseLPane = undefined;
    SessionInfo.searchFunc = this.searchDefault;
  }
  state = {
    //------ Integer Values - Companies ------
    CompanyID: 0,
    AccountStartDate: 0,
    CompanyTypeID: 0,
    CompanyStatusID: 0,
    ParentCompanyID: 0,
    ProvinceStateID: 0,
    CountryID: 0,
    SalesGroupID: 0,
    SalesPersonID: 0,
    InvoiceGroupID: 0,
    MonthPeriodType: 0,
    CurrentMonthEnd: 0,
    CompanyLogo: 0,
    CompanyLogoImageURL: '',
    CompanyImage: 0,
    CompanyImageURL: '',
    IsRecordActive: 0,
    ControlFlags: 0,
    CreatedBy: 0,
    CreatedOn: 0,
    LastModifiedBy: 0,
    LastModifiedOn: 0,
    AppEntityID: 0,
    AppGroupID: 0,

    //------ String Values - Companies ------
    CompanyName: '',
    CompanyCode: '',
    CompanyDBA: '',
    CompanyLegalName: '',
    AccountNumber: '',
    MainBusinessPhone: '',
    MainEmailAddress: '',
    PrimeContactName: '',
    FaxNumber: '',
    TollFreeNumber: '',
    MainCellNumber: '',
    AlternatePhoneNumber: '',
    WebSite: '',
    TAXNumber: '',
    TAX2Number: '',
    DUNSNumber: '',
    UnitNumber: '',
    Address: '',
    City: '',
    PostalCode: '',
    CompanyUserName: '',
    Description: '',
    Comments: '',

    //------ Dictionary Arrays - Companies ------
    StoreLocationsData: [],
    CompaniesDict: [],
    CompanyTypeIDVals: [],
    CompanyStatusDict: [],
    CompaniesDict: [],
    ProvinceStateCodesDict: [],
    CountriesDict: [],
    SalesGroupsDict: [],
    ResourcesDict: [],
    InvoiceGroupsDict: [],
    MonthPeriodTypes: [],
    PersonsDict: [],
    PersonsDict: [],
    AppEntitiesDict: [],
    PersonsDict: [],
    StoreLocationsDict: [],
    OrderTypesDict: [],
    DaysOfWeek: [],

    //------ Integer Values - CheckoutControls ------
    CheckoutControlID: 0,
    CompanyID: 0,
    MaximumStoreCount: 0,
    HoldProblemDays: 0,
    HoldAbandonedDays: 0,
    CompanyAppEntityID: 0,
    MaxMonthsForReceipts: 0,
    MaximumProductCount: 0,
    MaximumUserCount: 0,

    //------ String Values - CheckoutControls ------

    //------ Dictionary Arrays - CheckoutControls ------
    CheckoutControlsDict: [],
    CompaniesDict: [],

    //------ Integer Values - EntityConfiguration ------
    EntityConfigurationID: 0,
    CompanyID: 0,
    StorePromotionID: 0,
    StorePromotion2: 0,
    StorePromotion3: 0,
    StorePromotion4: 0,
    DefaultStoreLocationID: 0,
    DefaultOrderType: 0,
    GeoFenceMeters: 0,
    BaseDayOfWeek: 0,
    Tax1Percent: 0,
    Tax2Percent: 0,
    Tax3Percent: 0,
    ApplicationConfiguration: 0,
    LayoutConfiguration: 0,
    LastUpdatedOn: 0,
    ProcessCommand: 0,

    //------ String Values - EntityConfiguration ------
    Promo1Link: '',
    Promo2Link: '',
    Promo3Link: '',
    Promo4Link: '',
    GreetingMessage: '',
    SecondMessage: '',
    InputTextColor: '',
    InputBGColor: '',
    InputBorderColor: '',
    ButtonTextColor: '',
    ButtonBGColor: '',
    HeadingTextColor: '',
    ItemNameColor: '',
    ItemDescColor: '',
    PromptColor: '',
    ListBGColor: '',
    ListHeadTextColor: '',
    ListHeadBGColor: '', 
    ListSectionTextColor: '',
    ListSectionBGColor: '',
    BrandColor: '',
    BrandLogo: 0,
    BrandLogoImageURL: undefined,
    BackgroundImage: 0,
    BackgroundImageURL: undefined,
    LogoColor: '',
    BackgroundColor: '',
    RegistrationCode: '',
    //-------------------------------------------------------------
    // Fonts
    InputFontType: 0,
    InputFontSize: 0,
    InputTextSample: 'Sample Text 1234 ABC #$%',
    ButtonFontType: 0,
    ButtonFontSize: 0,
    ButtonSample: 'Sample Text 1234 ABC #$%',
    HeadingFontType: 0,
    HeadingFontSize: 0,
    HeadingSample: 'Sample Text 1234 ABC #$%',
    ItemNameFontType: 0,
    ItemNameFontSize: 0,
    ItemNameSample: 'Sample Text 1234 ABC #$%',
    ItemDescFontType: 0,
    ItemDescFontSize: 0,
    ItemDescSample: 'Sample Text 1234 ABC #$%',
    ListFontType: 0,
    ListFontSize: 0,
    ListSample: 'Sample Text 1234 ABC #$%',
    HeadFontType: 0,
    HeadFontSize: 0,
    HeadSample: 'Sample Text 1234 ABC #$%',
    SectionFontType: 0,
    SectionFontSize: 0,
    SectionSample: 'Sample Text 1234 ABC #$%',
    PromptFontType: 0,
    PromptFontSize: 0,
    PromptSample: 'Sample Text 1234 ABC #$%',

    //------ Encoded Bit Values For ApplicationConfiguration -------
    ScanAndPay: false,
    OrderAndPay: false,
    ScanPayIndividualItems: false,
    HasIngredients: false,
    HasOrderToTable: false,
    HasDelivery: false,
    HasTip: false,
    HasItemLookup: false,
    HasRecipeLookup: false,
    HasStorePromotion: false,
    HasAccountInfo: false,
    HasGiftCards: false,
    HasCoupons: false,
    HasShoppingList: false,
    CategoryPage: false,
    HasPartialPayment: false,
    HasSeats: false,
    HasGuestInvite: false,
    HasDiscounts: false,
    HasCredit: false,
    HasReturns: false,
    HasTax1: false,
    HasTax2: false,
    HasTax3: false,
    HasWorkflow: false,
    HasCashPayment: false,
    HasVoidOrder: false,
    HasVoidItem: false,
    LayoutConfiguration: 0,

    //------ Encoded Bit Values For LayoutConfiguration -------
    HasLandingPage: false,
    HasLocationInfo: false,
    HasBackgroundMenuImage: false,
    UseMenuLayout1: false,
    UseMenuLayout2: false,
    UseMenuLayout3: false,
    UseMenuLayout4: false,
    UseMenuLayout5: false,
    UseMenuLayout6: false,
    UseMenuLayout7: false,
    UseMenuLayout8: false,
    HasGroupMenus: false,
    DropBoxBorders: false,
    WideSpacing: false,
    CategoryImages: false,
    OptionImages: false,
    TwoLevelGroup: false,
    RetailConfiguration: false,
    LastUpdatedOn: 0,
    ProcessCommand: 0,
    ApplicationTypeID: 0,

    //------ Encoded Bit Values For InteractControls -------
    AppDebugMode: false,
    TimeOfDayControl: false,
    SeasonControl: false,
    DayOfWeekControl: false,
    PriceOverrideControl: false,
    ControlInventory: false,
    OrderingControl: false,

    //------ Dictionary Arrays - EntityConfiguration ------
    InteractControls: 0,
    InteractControlsVals: [],
    EntityConfigurationDict: [],
    StorePromotionsDict: [],
    Companies: [],
    ApplicationConfigurationVals: [],
    LayoutConfigurationVals: [],
    EntityConfigurations: [],
    CheckoutControls: [],
    ProcessCommands: [],

    selectedColor: '',
    searchValue: '',
    MessagesValue: '',
    currentTime: '',
    stateHasChanged: false,
    itemStateHasChanged: false,
  };
  helpListPopupOffset = { left: 150,top: 60 };
  helpDetailOffset = { left: 200,top: 120 };

  file = undefined;
  refreshCount = 6;
  compUpdate = true;
  //subInteract = "https://interactmenu.com/?tableid=2&locationid=1&token=%27rwXvl7IzPpzMtm9t+YsGSHDyL5xa7StbwH7RsksFg8dpATO8lnPji8vWtH7ROq2ohOT/u1b6Rnr2KEYg1oDXKipO4zJBTHMj0RLfSgEgrKG9PMqCQ+LA/2MUro5pke4EMnYwuLFx2vKe7lvBAmE9nzwlUqS1xfO9t6Sd+GwM1OQ=%27#logon40004"
  subInteract = "https://admin.interactapp.com/?tableid=2&locationid=1&token=%27rwXvl7IzPpzMtm9t+YsGSHDyL5xa7StbwH7RsksFg8dpATO8lnPji8vWtH7ROq2ohOT/u1b6Rnr2KEYg1oDXKipO4zJBTHMj0RLfSgEgrKG9PMqCQ+LA/2MUro5pke4EMnYwuLFx2vKe7lvBAmE9nzwlUqS1xfO9t6Sd+GwM1OQ=%27#logon40004"
  StoreLocationsData = [];
  SubLocations = [];
  clearScreen = false;

  tabs = {
    CompanyInfo: 0,
    Settings: 1,
    Config: 2,
    Images: 3,
    MENUAPP: 4,
  }

  async componentDidMount() {
    if (!SessionInfo.session || SessionInfo.forceLogoff === true) {
      console.log(`forceLogoff set in SettingsPage - go to Login`);
      this.props.navigate("/Login");
    }
    SessionInfo.currentPage = "SettingsPage";
    //SessionInfo.searchTitle = "Search Categories";
    SessionInfo.searchFunc = this.searchCurrent;
    SessionInfo.tabSelectFunc = this.selectTab;
    SessionInfo.currSaveFunc = this.saveCompany;
    SessionInfo.currDeleteFunc = this.deleteRecord;
    SessionInfo.currClearFunc = this.clearRecord;
    SessionInfo.currRefreshGridFunc = this.refreshGrid;
    SessionInfo.currAddGridRowFunc = undefined;
    SessionInfo.currExcelExportFunc = undefined;
    await this.initializeDictionaries();
    SessionInfo.setShowSave = 2; // Turn off
    console.log(`Settings - AppEntityID: ${SessionInfo.AppEntityID}`);
    this.setState({ AppEntityID: SessionInfo.AppEntityID });
    await this.selectTab(0);
  }
  componentDidUpdate() {
    //let value = this.context;
  }
  componentWillUnmount() {
    if (SessionInfo.session !== '')
      SessionInfo.SettingsPage = this.state;
    setCSSVariable('--prompt-left','130px');
  }
  shouldComponentUpdate() {
    //console.log("Should Update?");
    if (this.compUpdate === true)
      return true;
    else
      return false;
  }
  handleTopTabSelect = async (e) => { // Tab Selection
    await this.selectTab(e.selected);
  }
  selectTab = async (tabNumber) => { // Note - Load Dictionaries based on Tab
    console.log(`Tab Select in Manager - Tab: ${tabNumber}`);
    this.searchAlt = 0;
    //let horizontalPanes = [{ collapsible: false, min: '65%', collapsed: false }, { collapsible: true, collapsed: true }]; // Left/Right
    try {
      if (SessionInfo.clearSearch)
        SessionInfo.clearSearch();
      this.setState({ bottomDisplay: 0 });
      SessionInfo.setShowSave = 2; // Turn off Save in Header 
      SessionInfo.setGridAdd = 2;
      SessionInfo.setShowNew = 2;
      SessionInfo.setExcelExport = 2;
      SessionInfo.setGridRefresh = 2;
      if (tabNumber === this.tabs.CompanyInfo) {
        //SessionInfo.searchTitle = "Search Menu Help";
        setCSSVariable('--prompt-left','130px');
        await this.getCompany();
        //SessionInfo.setShowSave = 2; // Turn off 
        //SessionInfo.currSaveFunc = this.saveCompany;
      }
      else if (tabNumber === this.tabs.Settings) {
        //SessionInfo.searchTitle = "Search Manager Help";
        setCSSVariable('--prompt-left','170px');
        await this.getCheckoutControls();
        //SessionInfo.setShowSave = 1; // Turn on 
        //SessionInfo.currSaveFunc = this.saveCheckoutControls;
      }
      else if (tabNumber === this.tabs.Config) {
        setCSSVariable('--prompt-left','130px');
        if (this.state.EntityConfigurationID == 0) {
          await this.getEntityConfiguration();
        }
        //SessionInfo.setShowSave = 1; // Turn on 
        //SessionInfo.currSaveFunc = this.saveEntityConfiguration;
      }
      else if (tabNumber === this.tabs.Images) {
        setCSSVariable('--prompt-left','130px');
        if (this.state.EntityConfigurationID == 0) {
          await this.getEntityConfiguration();
        }
        //SessionInfo.setShowSave = 1; // Turn on 
        //SessionInfo.currSaveFunc = this.saveEntityConfiguration;
      }
      else if (tabNumber === this.tabs.MENUAPP) { // Menu App 
        if (this.state.stateHasChanged === true) {
          console.log(`state HAS Changed`);
          if (SessionInfo.onChangeAskSave === true) {
            let okay = window.confirm(`Save Current Changes to Settings?`);
            if (okay === false) {
              displayMessage("Changes to the Current Settings Abandoned");
            }
            else {
              await this.saveCompany();
            }
          }
          else {
            let okay = window.confirm(`Abandon Current Changes to Settings?`);
            if (okay === false) {
              displayMessage("Row must be Saved First");
              return;
            }
            displayMessage("Changes to the Current Settings Abandoned");
          }
        }
        this.setState({ verticalPanes: this.vertSplitC });
        if (this.StoreLocationsData.length <= 0) {
          await this.getStoreLocations();
        }
        console.log(`Locations Cnt: ${this.StoreLocationsData.length}`);
        if (this.StoreLocationsData.length > 0) {
          console.log(`get SubLocations for Location: ${this.StoreLocationsData[0].LocationID}`);
          console.log(`CheckoutToken: ${SessionInfo.CheckoutToken}`);
          await this.getSublocations(this.StoreLocationsData[0].LocationID);
          let menuAppStr;
          console.log(`Debug: ${SessionInfo.debug}`);
          if (SessionInfo.debug === true)
            menuAppStr = `http://localhost:3001/?tableid=${this.Sublocations[0].SublocationID}&locationid=${this.StoreLocationsData[0].StoreLocationID}&token=${SessionInfo.CheckoutToken}#logon40004`;
          else
            menuAppStr = `https://admin.interactsuite.app/?tableid=${this.Sublocations[0].SublocationID}&locationid=${this.StoreLocationsData[0].StoreLocationID}&token=${SessionInfo.CheckoutToken}#logon40004`;
          console.log(`menuAppStr: ${menuAppStr}`);
          this.subInteract = menuAppStr;
        }
        // Set LocationID to current Location
      }
      this.setState({ selectedTopTab: tabNumber });
    }
    catch (ex) {
      displayError(`Error in Tab Select: ${ex}`);
    }
  }
  getStoreLocations = async () => { // Get the available StoreLocations
    let CD = await GetTableDataRaw(545207); // Get StoreInfoView
    if (CD.x.o >= 9000 && CD.x.o < 9500) {
      try {
        this.StoreLocationsData = CD.d.rows;
        console.log(`get StoreLocations: ${JSON.stringify(this.StoreLocationsData)}`)
        this.setState({ StoreLocationsData: this.StoreLocationsData });
      } catch (error) {
        console.log(error.message);
      }
    }
    else {
      displayError("Unable to retrieve Locations");
      this.setState({ StoreLocationsData: [] });
    }
  }
  getSublocations = async (locationID) => {
    if (Number.isInteger(locationID) === false) {
      console.log("*NOT INTEGER* locationID: " + locationID + " - getSubLocations ");
    } else {
      let search = "*LocationID=" + locationID; // NOTE - Sublocations is based on LocationID - NOT StoreLocationID   
      let CD = await GetTableSearchRaw(517732,search,"SublocationID,Sublocation,Description,SublocationTypeID,LocationID,IsRecordActive");
      try {
        this.Sublocations = CD.d.rows;
        this.setState({ Sublocations: this.Sublocations });
      } catch (error) {
        displayError("getSublocations: " + error.message);
      }
    }
  }

  initializeDictionaries = async () => {
    // Dictionary Load
    if (this.state.CompanyStatusDict.length <= 1) {
      let CD = await GetDropdownData(489009);
      this.setState({ CompanyStatusDict: CD.d });
    }
    if (this.state.ProvinceStateCodesDict.length <= 1) {
      let CD = await GetDropdownData(489030);
      this.setState({ ProvinceStateCodesDict: CD.d });
    }
    if (this.state.CountriesDict.length <= 1) {
      let CD = await GetDropdownData(154824);
      this.setState({ CountriesDict: CD.d });
    }
    //------ Initialization Code - CheckoutControls ------
    if (this.state.CheckoutControlsDict.length <= 1) {
      let CD = await GetDropdownData(546475);
      this.setState({ CheckoutControlsDict: CD.d });
    }
    if (this.state.CompaniesDict.length <= 1) {
      let CD = await GetDropdownData(488610);
      this.setState({ CompaniesDict: CD.d });
    }
    //------ Initialization Code - StoreLocations ------
    if (this.state.StoreLocationsDict.length <= 1) {
      let CD = await GetDropdownData(544596);
      this.setState({ StoreLocationsDict: CD.d });
    }
    if (this.state.OrderTypesDict.length <= 1) {
      let CD = await GetDropdownData(545100);
      this.setState({ OrderTypesDict: CD.d });
    }
    //------ Initialization Code - EntityConfiguration ------
    if (this.state.EntityConfigurationDict.length <= 1) {
      let CD = await GetDropdownData(546692);
      this.setState({ EntityConfigurationDict: CD.d });
    }
    if (this.state.CompaniesDict.length <= 1) {
      let CD = await GetDropdownData(488610);
      this.setState({ CompaniesDict: CD.d });
    }
    if (this.state.StorePromotionsDict.length <= 1) {
      let CD = await GetDropdownData(544701);
      this.setState({ StorePromotionsDict: CD.d });
    }
    if (this.state.ProcessCommands.length <= 1) {
      let CD = await GetDropdownData(547556);
      this.setState({ ProcessCommands: CD.d });
    }
    //  if (this.state.SalesGroupsDict.length <= 1) {
    //    let CD = await GetDropdownData(1120659);
    //    this.setState({ SalesGroupsDict: CD.d });
    //  }
    //  if (this.state.ResourcesDict.length <= 1) {
    //    let CD = await GetDropdownData(1000558);
    //    this.setState({ ResourcesDict: CD.d });
    //  }
    //  if (this.state.InvoiceGroupsDict.length <= 1) {
    //    let CD = await GetDropdownData(541245);
    //    this.setState({ InvoiceGroupsDict: CD.d });
    //  }
    //  if (this.state.MonthPeriodTypes.length <= 1) {
    //    let CD = await GetDropdownData(541252);
    //    this.setState({ MonthPeriodTypes: CD.d });
    //  }
  }
  moneyFormat = (value) => new Intl.NumberFormat('en-US',{ style: 'currency',currency: 'USD' }).format(value);

  getCompany = async () => {
    let CD = await CallOM("GetCompanyForEntity",0,0,0);
    //let CD = await GetTableRow(544596, Key); // Get the current StoreLocation
    console.log("after GetCompanyForEntity: " + JSON.stringify(CD.d));
    let row = CD.d;
    //this.setState({ Companies: row });
    // Retrieved Value Assignment for: Companies
    CompaniesO.forEach((elem) => {
      if (elem.n in row) {
        //console.log(`Set ${elem.n}: ${row[elem.n]}`);
        let sobj = {};
        try {
          if (elem.t === 34 || elem.t === 35) { // Date, DateTime
            //sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
            sobj[elem.n] = row[elem.n];
            CV[elem.n] = new Date(row[elem.n]);
          } else if (elem.t === 21 || elem.t === 195 || elem.t === 201) { // String, FK-Translated, Enum
            sobj[elem.n] = row[elem.n];
            let sobjS = {};
            sobjS[elem.n + 'S'] = row[elem.n];
            //console.log(`Set String Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
            this.setState(sobjS); // Set the String shadow var
            CV[elem.n] = row[elem.n];
          } else if (elem.t === 28) { // Money
            sobj[elem.n] = row[elem.n];
            let sobjS = {};
            sobjS[elem.n + 'S'] = this.moneyFormat(row[elem.n]);
            //console.log(`Set Money Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
            this.setState(sobjS); // Set the String shadow var
            CV[elem.n] = row[elem.n];
          } else if (elem.t === 41) { // Media - Image or Document
            sobj[elem.n] = row[elem.n];
            CV[elem.n] = row[elem.n];
            if (elem.n === 'ImageID')
              currentImageID = row[elem.n];
          } else if (elem.t === 15) { // Encoded
            //------ Assign Encoded Values ------
            if ("CompanyTypeID" === elem.n) {
              // Assignment for CompanyTypeID
              let EncodeList = [];
              let EncodeVal = row[elem.n];
              if ((EncodeVal & (0x0000000000000001 << 6)) === (0x0000000000000001 << 6))
                EncodeList.push('Account Owner');
              if ((EncodeVal & (0x0000000000000001 << 1)) === (0x0000000000000001 << 1))
                EncodeList.push('SKU Owner');
              if ((EncodeVal & (0x0000000000000001 << 4)) === (0x0000000000000001 << 4))
                EncodeList.push('Producer');
              if ((EncodeVal & (0x0000000000000001 << 5)) === (0x0000000000000001 << 5))
                EncodeList.push('Shipper');
              if ((EncodeVal & (0x0000000000000001 << 11)) === (0x0000000000000001 << 11))
                EncodeList.push('Supplier');
              if ((EncodeVal & (0x0000000000000001 << 8)) === (0x0000000000000001 << 8))
                EncodeList.push('Carrier');
              if ((EncodeVal & (0x0000000000000001 << 7)) === (0x0000000000000001 << 7))
                EncodeList.push('Consignee');
              if ((EncodeVal & (0x0000000000000001 << 3)) === (0x0000000000000001 << 3))
                EncodeList.push('Broker');
              if ((EncodeVal & (0x0000000000000001 << 2)) === (0x0000000000000001 << 2))
                EncodeList.push('Retailer');
              if ((EncodeVal & (0x0000000000000001 << 12)) === (0x0000000000000001 << 12))
                EncodeList.push('Regulatory');
              if ((EncodeVal & (0x0000000000000001 << 20)) === (0x0000000000000001 << 20))
                EncodeList.push('Other');
              this.setState({ CompanyTypeIDVals: EncodeList });
            }
            sobj[elem.n] = row[elem.n];
            CV[elem.n] = row[elem.n];
          } else {
            sobj[elem.n] = row[elem.n];
            CV[elem.n] = row[elem.n];
          }
          //console.log(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${CV[elem.n]}`);
          this.setState(sobj);
          // Add item specific code here
          //if (elem.n === 'ImageID')
          //  ImageID = row[elem.n];
        }
        catch (error) {
          console.log(`Set CompaniesO Field: ${elem.n}, Error: ${error.message}`);
        }
      }
    });
    console.log(`get company image for company ID: ${this.state.CompanyID}, CV: ${CV.CompanyID}, Logo: ${CV.CompanyLogo}, Image: ${CV.CompanyImage}`);
    if (CV.CompanyLogo !== 0)
      await this.getCompanyLogoImage(CV.CompanyLogo);
    else
      await this.getCompanyLogoImage(2);
    if (CV.CompanyImage !== 0)
      await this.getCompanyImage(CV.CompanyImage);
    else
      await this.getCompanyImage(2);
    await this.getEntityConfiguration();
  }
  saveCompany = async () => { // saveRecord
    //console.log("Save CustomerProfile");
    let propState = {};
    CompaniesO.forEach((elem) => {
      if (elem.n in this.state) {
        propState[elem.n] = this.state[elem.n];
      }
    });
    //console.log("propState: " + JSON.stringify(propState));
    let CD = await CallOM("SaveCompanyForEntity",0,0,CTYP.DICTNO,propState);
    //await UpdateRow(543619, 0, copyState, copyState.CustomerID, "CustomerID"); // Save to OM
    //await this.getRecords();
    await this.saveCheckoutControls();
    await this.saveEntityConfiguration();
    this.setItemStateChanged(false);
  }
  getCompanyLogoImage = async (imageID) => {
    console.log(`GetCompanyLogo: ${imageID}`);
    const imageURL = await getImageFileFromServer(imageID);
    this.setState({ CompanyLogoImageURL: imageURL });
  }
  getCompanyImage = async (imageID) => {
    console.log(`GetCompanyImage: ${imageID}`);
    const imageURL = await getImageFileFromServer(imageID);
    this.setState({ CompanyImageURL: imageURL });
  }
  // Get CheckoutControls 
  getCheckoutControls = async () => {
    let CD = await CallOM("GetCheckoutControlsForEntity",0,0,0);
    console.log("after GetCheckoutControlsForEntity: " + JSON.stringify(CD.d));
    let row = CD.d;
    //this.setState({ CheckoutControls: row });   
    // Retrieved Value Assignment for: CheckoutControls
    CheckoutControlsO.forEach(elem => {
      if (elem.n in row) {
        //console.log(`Set ${elem.n}: ${row[elem.n]}`);
        let sobj = {};
        try {
          if (elem.t === 34 || elem.t === 35) { // Date, DateTime
            sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
            //sobj[elem.n] = row[elem.n];
            CCV[elem.n] = new Date(row[elem.n]);
          } else if (elem.t === 21 || elem.t === 195 || elem.t === 201) { // String, FK-Translated, Enum
            sobj[elem.n] = row[elem.n];
            let sobjS = {};
            sobjS[elem.n + 'S'] = row[elem.n];
            //console.log(`Set String Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
            this.setState(sobjS); // Set the String shadow var
            CCV[elem.n] = row[elem.n];
          } else if (elem.t === 22) { // Bool
            let val = row[elem.n].toString().charAt();
            if (val === '1' || val === 't' || val === 'T') {
              sobj[elem.n] = true;
              COV[elem.n] = true;
            } else {
              sobj[elem.n] = false;
              COV[elem.n] = false;
            }
          } else if (elem.t === 28) { // Money
            sobj[elem.n] = row[elem.n];
            let sobjS = {};
            sobjS[elem.n + 'S'] = this.moneyFormat(row[elem.n]);
            //console.log(`Set Money Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
            this.setState(sobjS); // Set the String shadow var
            CCV[elem.n] = row[elem.n];
          } else if (elem.t === 41) { // Media - Image or Document
            sobj[elem.n] = row[elem.n];
            CCV[elem.n] = row[elem.n];
            if (elem.n === 'ImageID')
              currentImageID = row[elem.n];
          } else if (elem.t === 15) { // Encoded
            //------ Assign Encoded Values ------

            let AList = [];

            if (elem.n === 'InteractControls') {
              // Assignment for InteractControls
              let EncodeVal = row[elem.n];
              InteractControlsFixedValues.forEach((ent) => {
                if ((EncodeVal & (0x0000000000000001 << ent.k)) === (0x0000000000000001 << ent.k))
                  AList.push(ent.n);
              });
            }
            let sobjV = {};
            sobjV[`${elem.n}Vals`] = AList; // Set the Vals Array
            this.setState(sobjV); // Set the Vals var
            sobj[elem.n] = row[elem.n];
            //obj[elem.n] = row[elem.n];
            CCV[elem.n] = row[elem.n];
            console.log(`Encoded sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${CCV[elem.n]}`);
          } else { // Default - Number
            sobj[elem.n] = row[elem.n];
            CCV[elem.n] = row[elem.n];
          }
          //console.log(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${CCV[elem.n]}`);
          if (this.state[elem.n] === undefined)
            console.log(`=== ${elem.n} is not defined in state ===`);
          this.setState(sobj);
          // Add item specific code here
          //if (elem.n === 'ImageID')
          //  ImageID = row[elem.n];
        }
        catch (error) {
          console.log(`Set CheckoutControlsO Field: ${elem.n}, Error: ${error.message}`);
        }
      }
    });
  }
  saveCheckoutControls = async () => {
    //console.log("Save CustomerProfile");
    let propState = {};
    CheckoutControlsO.forEach((elem) => {
      if (elem.n in this.state) {
        propState[elem.n] = this.state[elem.n];
      }
    });
    //console.log("propState: " + JSON.stringify(propState));
    let CD = await CallOM("SaveCheckoutControlsForEntity",0,0,CTYP.DICTNO,propState);
    //await UpdateRow(543619, 0, copyState, copyState.CustomerID, "CustomerID"); // Save to OM 
    //await this.getRecords();
    this.setItemStateChanged(false);
  }
  // Get EntityConfigurationO
  getEntityConfiguration = async () => {
    // Retrieved Value Assignment for: EntityConfiguration
    try {
      let CD = await CallOM("GetEntityConfigurationForEntity",0,0,0);
      console.log("after GetEntityConfigurationForEntity: " + JSON.stringify(CD.d));
      let row = CD.d;
      this.setState({ EntityConfigurations: row });
      EntityConfigurationO.forEach((elem) => {
        if (elem.n in row) {
          //console.log(`Set ${elem.n}: ${row[elem.n]}`);
          let sobj = {};
          try {
            if (elem.t === 34 || elem.t === 35) { // Date, DateTime
              //sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
              sobj[elem.n] = row[elem.n];
              ECV[elem.n] = new Date(row[elem.n]);
            } else if (elem.t === 21 || elem.t === 195 || elem.t === 201) { // String, FK-Translated, Enum
              sobj[elem.n] = row[elem.n];
              let sobjS = {};
              sobjS[elem.n + 'S'] = row[elem.n];
              //console.log(`Set String Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
              this.setState(sobjS); // Set the String shadow var
              ECV[elem.n] = row[elem.n];
              if (elem.n.indexOf("Color") >= 0)        
               this.setColorVar(elem.n,row[elem.n]); 
            } else if (elem.t === 28) { // Money
              sobj[elem.n] = row[elem.n];
              let sobjS = {};
              sobjS[elem.n + 'S'] = this.moneyFormat(row[elem.n]);
              //console.log(`Set Money Field: ${elem.n + 'S'}, Value: ${ sobjS[elem.n + 'S']}`);
              this.setState(sobjS); // Set the String shadow var
              ECV[elem.n] = row[elem.n];
            } else if (elem.t === 41) { // Media - Image or Document
              sobj[elem.n] = row[elem.n];
              ECV[elem.n] = row[elem.n];
              if (elem.n === 'ImageID')
                currentImageID = row[elem.n];
            } else if (elem.t === 15) { // Encoded
              //------ Assign Encoded Values ------
              let AList = [];
              if ("ApplicationConfiguration" === elem.n) {
                let EncodeVal = row[elem.n];
                ApplicationConfigurationFixedValues.forEach((ent) => {
                  if ((EncodeVal & (0x0000000000000001 << ent.k)) === (0x0000000000000001 << ent.k))
                    AList.push(ent.n);
                });
                console.log("ApplicationConfiguration AList: " + JSON.stringify(AList));
              } else if ("LayoutConfiguration" === elem.n) {
                let EncodeVal = row[elem.n];
                LayoutConfigurationFixedValues.forEach((ent) => {
                  if ((EncodeVal & (0x0000000000000001 << ent.k)) === (0x0000000000000001 << ent.k))
                    AList.push(ent.n);
                });
                console.log("LayoutConfiguration AList: " + JSON.stringify(AList));
              }
              let sobjV = {};
              sobjV[`${elem.n}Vals`] = AList;
              this.setState(sobjV); // Set the Vals var
              //ECV[`${elem.n}Vals`] = AList;
              sobj[elem.n] = row[elem.n];
              ECV[elem.n] = row[elem.n];
              console.log(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${ECV[elem.n]}`);
            } else {
              sobj[elem.n] = row[elem.n];
              ECV[elem.n] = row[elem.n];
              if (elem.n.indexOf("Font") >= 0)
                this.setFontInfo(elem.n,row[elem.n]); 
            }
            //console.log(`sobj ${JSON.stringify(sobj)}, t: ${elem.t}, val: ${ECV[elem.n]}`);
            this.setState(sobj);
            // Add item specific code here
            //if (elem.n === 'ImageID')
            //  ImageID = row[elem.n];
          }
          catch (error) {
            console.log(`Set EntityConfigurationO Field: ${elem.n}, Error: ${error.message}`);
          }
        }
      });
      await this.setApplicationConfigurationBitEncoded(ECV.ApplicationConfiguration);
      await this.setLayoutConfigurationBitEncoded(ECV.LayoutConfiguration);
      await this.setInteractControlsBitEncoded(CCV.InteractControls);
      console.log(`Brand: ${ECV.BrandLogo}, Background: ${ECV.BackgroundImage}`);
      if (ECV.BrandLogo !== 0)
        await this.getBrandLogoImage(ECV.BrandLogo);
      else
        this.setState({ BrandLogoImageURL: getImageFileFromServer(0,0) });
        //await this.getBrandLogoImage(2);
      if (ECV.BackgroundImage !== 0)
        await this.getBackgroundImage(ECV.BackgroundImage);
      else
        this.setState({ BackgroundImageURL: getImageFileFromServer(0,0) });
        //await this.getBackgroundImage(2);
    }
    catch (error) {
      console.log(`Error in getEntityConfiguration: ${error}`);
    }
  }
  saveEntityConfiguration = async () => {
    console.log("====> Save saveEntityConfiguration");
    await this.getApplicationConfigurationBitEncoded();
    await this.getLayoutConfigurationBitEncoded();
    await this.getInteractControlsBitEncoded();
    this.forceUpdate();
    console.log(`*** ApplicationConfiguration: ${this.state.ApplicationConfiguration},  LayoutConfiguration: ${this.state.LayoutConfiguration},  InteractControls: ${this.state.InteractControls}`);
    let propState = {};
    EntityConfigurationO.forEach((elem) => {
      //console.log(elem.n);
      if (elem.n in this.state) { // Note - will not assign undefined to propState
        //console.log(`  In State: ${elem.n}`);
        propState[elem.n] = this.state[elem.n];
        //console.log(`  propState: ${propState[elem.n]}`);
      }
    });
    propState["ApplicationConfiguration"] = ECV.ApplicationConfiguration;
    propState["LayoutConfiguration"] = ECV.LayoutConfiguration;
    propState["InteractControls"] = CCV.InteractControls;
    console.log("==> saveEntityConfiguration: " + JSON.stringify(propState));
    let CD = await CallOM("SaveEntityConfigurationForEntity",0,0,CTYP.DICTNO,propState);
    //await UpdateRow(543619, 0, copyState, copyState.CustomerID, "CustomerID"); // Save to OM 
    //await this.getRecords();
    this.setItemStateChanged(false);
  }
  //--------------------------------------------------------------------------------------------------------------------------------------
  // Convert Encoded Bit-Values For InteractControls
  // ** Add to saveRecord  await this.getInteractControlsBitEncoded()
  getInteractControlsBitEncoded = async () => {
    let InteractControls = 0x0000000000000000;
    if (this.state.AppDebugMode === true)
      InteractControls |= (0x0000000000000001 << 1);
    if (this.state.TimeOfDayControl === true)
      InteractControls |= (0x0000000000000001 << 2);
    if (this.state.SeasonControl === true)
      InteractControls |= (0x0000000000000001 << 3);
    if (this.state.DayOfWeekControl === true)
      InteractControls |= (0x0000000000000001 << 4);
    if (this.state.PriceOverrideControl === true)
      InteractControls |= (0x0000000000000001 << 5);
    if (this.state.ControlInventory === true)
      InteractControls |= (0x001 << 6);
    if (this.state.OrderingControl === true)
      InteractControls |= (0x001 << 8);
    CCV.InteractControls = InteractControls;
    await this.setState({ InteractControls });
  }
  // Set State Variables for Encoded Bit-Values For InteractControls
  // ** Add to getRecord  await this.setInteractControlsBitEncoded(row[elem.n])
  setInteractControlsBitEncoded = async (InteractControlsVals) => {
    if ((InteractControlsVals & (0x0000000000000001 << 1)) === (0x0000000000000001 << 1))
      this.setState({ AppDebugMode: true });
    else
      this.setState({ AppDebugMode: false });
    if ((InteractControlsVals & (0x0000000000000001 << 2)) === (0x0000000000000001 << 2))
      this.setState({ TimeOfDayControl: true });
    else
      this.setState({ TimeOfDayControl: false });
    if ((InteractControlsVals & (0x0000000000000001 << 3)) === (0x0000000000000001 << 3))
      this.setState({ SeasonControl: true });
    else
      this.setState({ SeasonControl: false });
    if ((InteractControlsVals & (0x0000000000000001 << 4)) === (0x0000000000000001 << 4))
      this.setState({ DayOfWeekControl: true });
    else
      this.setState({ DayOfWeekControl: false });
    if ((InteractControlsVals & (0x0000000000000001 << 5)) === (0x0000000000000001 << 5))
      this.setState({ PriceOverrideControl: true });
    else
      this.setState({ PriceOverrideControl: false });
    if ((InteractControlsVals & (0x001 << 6)) === (0x001 << 6))
      this.setState({ ControlInventory: true });
    else
      this.setState({ ControlInventory: false });
    if ((InteractControlsVals & (0x001 << 8)) === (0x001 << 8))
      this.setState({ OrderingControl: true });
    else
      this.setState({ OrderingControl: false });
  }
  //--------------------------------------------------------------------------------------------------------------------------------------
  // Convert Encoded Bit-Values For ApplicationConfiguration
  // ** Add to saveRecord  await this.getApplicationConfigurationBitEncoded()
  getApplicationConfigurationBitEncoded = async () => {
    let ApplicationConfiguration = 0x0000000000000000;
    if (this.state.ScanAndPay === true)
      ApplicationConfiguration |= (0x0000000000000001 << 1);
    if (this.state.OrderAndPay === true)
      ApplicationConfiguration |= (0x0000000000000001 << 2);
    if (this.state.ScanPayIndividualItems === true)
      ApplicationConfiguration |= (0x0000000000000001 << 3);
    if (this.state.HasIngredients === true)
      ApplicationConfiguration |= (0x0000000000000001 << 5);
    if (this.state.HasOrderToTable === true)
      ApplicationConfiguration |= (0x0000000000000001 << 6);
    if (this.state.HasDelivery === true)
      ApplicationConfiguration |= (0x0000000000000001 << 7);
    if (this.state.HasTip === true)
      ApplicationConfiguration |= (0x0000000000000001 << 4);
    if (this.state.HasItemLookup === true)
      ApplicationConfiguration |= (0x0000000000000001 << 8);
    if (this.state.HasRecipeLookup === true)
      ApplicationConfiguration |= (0x0000000000000001 << 9);
    if (this.state.HasStorePromotion === true)
      ApplicationConfiguration |= (0x0000000000000001 << 10);
    if (this.state.HasAccountInfo === true)
      ApplicationConfiguration |= (0x0000000000000001 << 11);
    if (this.state.HasGiftCards === true)
      ApplicationConfiguration |= (0x0000000000000001 << 12);
    if (this.state.HasCoupons === true)
      ApplicationConfiguration |= (0x0000000000000001 << 13);
    if (this.state.HasShoppingList === true)
      ApplicationConfiguration |= (0x0000000000000001 << 14);
    if (this.state.CategoryPage === true)
      ApplicationConfiguration |= (0x0000000000000001 << 15);
    if (this.state.HasPartialPayment === true)
      ApplicationConfiguration |= (0x0000000000000001 << 16);
    if (this.state.HasSeats === true)
      ApplicationConfiguration |= (0x0000000000000001 << 17);
    if (this.state.HasGuestInvite === true)
      ApplicationConfiguration |= (0x0000000000000001 << 18);
    if (this.state.HasDiscounts === true)
      ApplicationConfiguration |= (0x0000000000000001 << 19);
    if (this.state.HasCredit === true)
      ApplicationConfiguration |= (0x0000000000000001 << 20);
    if (this.state.HasReturns === true)
      ApplicationConfiguration |= (0x0000000000000001 << 22);
    if (this.state.HasTax1 === true)
      ApplicationConfiguration |= (0x0000000000000001 << 24);
    if (this.state.HasTax2 === true)
      ApplicationConfiguration |= (0x0000000000000001 << 25);
    if (this.state.HasTax3 === true)
      ApplicationConfiguration |= (0x0000000000000001 << 26);
    if (this.state.HasWorkflow === true)
      ApplicationConfiguration |= (0x0000000000000001 << 27);
    if (this.state.HasCashPayment === true)
      ApplicationConfiguration |= (0x0000000000000001 << 28);
    if (this.state.HasVoidOrder === true)
      ApplicationConfiguration |= (0x0000000000000001 << 29);
    if (this.state.HasVoidItem === true)
      ApplicationConfiguration |= (0x0000000000000001 << 30);
    console.log(`save AppConfigBits - ${ApplicationConfiguration}`);
    ECV.ApplicationConfiguration = ApplicationConfiguration; // Need to add this to generation
    await this.setState({ ApplicationConfiguration });
  }
  // Set State Variables for Encoded Bit-Values For ApplicationConfiguration
  // ** Add to getRecord  await this.setApplicationConfigurationBitEncoded(row[elem.n])
  setApplicationConfigurationBitEncoded = async (ApplicationConfigurationVals) => {
    console.log(`setAppConfigBits - ${ApplicationConfigurationVals}`);
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 1)) === (0x0000000000000001 << 1))
      this.setState({ ScanAndPay: true });
    else
      this.setState({ ScanAndPay: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 2)) === (0x0000000000000001 << 2))
      this.setState({ OrderAndPay: true });
    else
      this.setState({ OrderAndPay: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 3)) === (0x0000000000000001 << 3))
      this.setState({ ScanPayIndividualItems: true });
    else
      this.setState({ ScanPayIndividualItems: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 5)) === (0x0000000000000001 << 5))
      this.setState({ HasIngredients: true });
    else
      this.setState({ HasIngredients: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 6)) === (0x0000000000000001 << 6))
      this.setState({ HasOrderToTable: true });
    else
      this.setState({ HasOrderToTable: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 7)) === (0x0000000000000001 << 7))
      this.setState({ HasDelivery: true });
    else
      this.setState({ HasDelivery: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 4)) === (0x0000000000000001 << 4))
      this.setState({ HasTip: true });
    else
      this.setState({ HasTip: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 8)) === (0x0000000000000001 << 8))
      this.setState({ HasItemLookup: true });
    else
      this.setState({ HasItemLookup: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 9)) === (0x0000000000000001 << 9))
      this.setState({ HasRecipeLookup: true });
    else
      this.setState({ HasRecipeLookup: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 10)) === (0x0000000000000001 << 10))
      this.setState({ HasStorePromotion: true });
    else
      this.setState({ HasStorePromotion: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 11)) === (0x0000000000000001 << 11))
      this.setState({ HasAccountInfo: true });
    else
      this.setState({ HasAccountInfo: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 12)) === (0x0000000000000001 << 12))
      this.setState({ HasGiftCards: true });
    else
      this.setState({ HasGiftCards: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 13)) === (0x0000000000000001 << 13))
      this.setState({ HasCoupons: true });
    else
      this.setState({ HasCoupons: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 14)) === (0x0000000000000001 << 14))
      this.setState({ HasShoppingList: true });
    else
      this.setState({ HasShoppingList: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 15)) === (0x0000000000000001 << 15))
      this.setState({ CategoryPage: true });
    else
      this.setState({ CategoryPage: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 16)) === (0x0000000000000001 << 16))
      this.setState({ HasPartialPayment: true });
    else
      this.setState({ HasPartialPayment: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 17)) === (0x0000000000000001 << 17))
      this.setState({ HasSeats: true });
    else
      this.setState({ HasSeats: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 18)) === (0x0000000000000001 << 18))
      this.setState({ HasGuestInvite: true });
    else
      this.setState({ HasGuestInvite: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 19)) === (0x0000000000000001 << 19))
      this.setState({ HasDiscounts: true });
    else
      this.setState({ HasDiscounts: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 20)) === (0x0000000000000001 << 20))
      this.setState({ HasCredit: true });
    else
      this.setState({ HasCredit: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 22)) === (0x0000000000000001 << 22))
      this.setState({ HasReturns: true });
    else
      this.setState({ HasReturns: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 24)) === (0x0000000000000001 << 24))
      this.setState({ HasTax1: true });
    else
      this.setState({ HasTax1: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 25)) === (0x0000000000000001 << 25))
      this.setState({ HasTax2: true });
    else
      this.setState({ HasTax2: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 26)) === (0x0000000000000001 << 26))
      this.setState({ HasTax3: true });
    else
      this.setState({ HasTax3: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 27)) === (0x0000000000000001 << 27))
      this.setState({ HasWorkflow: true });
    else
      this.setState({ HasWorkflow: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 28)) === (0x0000000000000001 << 28))
      this.setState({ HasCashPayment: true });
    else
      this.setState({ HasCashPayment: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 29)) === (0x0000000000000001 << 29))
      this.setState({ HasVoidOrder: true });
    else
      this.setState({ HasVoidOrder: false });
    if ((ApplicationConfigurationVals & (0x0000000000000001 << 30)) === (0x0000000000000001 << 30))
      this.setState({ HasVoidItem: true });
    else
      this.setState({ HasVoidItem: false });
  }
  // Clear State Variables for Encoded Bit-Values For ApplicationConfiguration
  // ** Add to clearRecord  await this.clearApplicationConfigurationBitEncoded()
  clearApplicationConfigurationBitEncoded = async () => {
    this.setState({ ScanAndPay: false });
    this.setState({ OrderAndPay: false });
    this.setState({ ScanPayIndividualItems: false });
    this.setState({ HasIngredients: false });
    this.setState({ HasOrderToTable: false });
    this.setState({ HasDelivery: false });
    this.setState({ HasTip: false });
    this.setState({ HasItemLookup: false });
    this.setState({ HasRecipeLookup: false });
    this.setState({ HasStorePromotion: false });
    this.setState({ HasAccountInfo: false });
    this.setState({ HasGiftCards: false });
    this.setState({ HasCoupons: false });
    this.setState({ HasShoppingList: false });
    this.setState({ CategoryPage: false });
    this.setState({ HasPartialPayment: false });
    this.setState({ HasSeats: false });
    this.setState({ HasGuestInvite: false });
    this.setState({ HasDiscounts: false });
    this.setState({ HasCredit: false });
    this.setState({ HasReturns: false });
    this.setState({ HasTax1: false });
    this.setState({ HasTax2: false });
    this.setState({ HasTax3: false });
    this.setState({ HasWorkflow: false });
    this.setState({ HasCashPayment: false });
    this.setState({ HasVoidOrder: false });
    this.setState({ HasVoidItem: false });
  }
  //-------------------------------------------------------------------------------------------------------------------------------------- 
  // Convert Encoded Values For LayoutConfiguration
  // ** Add to saveRecord  await this.getLayoutConfigurationEncoded()
  getLayoutConfigurationEncoded = async () => {
    let LayoutConfiguration = 0x0000000000000000;
    let VList = this.state.LayoutConfigurationVals;
    if (VList.includes('HasLandingPage'))
      LayoutConfiguration |= (0x001 << 1);
    if (VList.includes('HasLocationInfo'))
      LayoutConfiguration |= (0x001 << 2);
    if (VList.includes('HasBackgroundMenuImage'))
      LayoutConfiguration |= (0x001 << 3);
    if (VList.includes('UseMenuLayout1'))
      LayoutConfiguration |= (0x001 << 4);
    if (VList.includes('UseMenuLayout2'))
      LayoutConfiguration |= (0x001 << 5);
    if (VList.includes('UseMenuLayout3'))
      LayoutConfiguration |= (0x001 << 6);
    if (VList.includes('UseMenuLayout4'))
      LayoutConfiguration |= (0x001 << 7);
    if (VList.includes('UseMenuLayout5'))
      LayoutConfiguration |= (0x001 << 8);
    if (VList.includes('UseMenuLayout6'))
      LayoutConfiguration |= (0x001 << 9);
    if (VList.includes('UseMenuLayout7'))
      LayoutConfiguration |= (0x001 << 10);
    if (VList.includes('UseMenuLayout8'))
      LayoutConfiguration |= (0x001 << 11);
    if (VList.includes('HasGroupMenus'))
      LayoutConfiguration |= (0x001 << 15);
    if (VList.includes('RetailConfiguration'))
      LayoutConfiguration |= (0x001 << 16);
    if (VList.includes('DropBoxBorders'))
      LayoutConfiguration |= (0x001 << 17);
    if (VList.includes('WideSpacing'))
      LayoutConfiguration |= (0x001 << 18);
    if (VList.includes('CategoryImages'))
      LayoutConfiguration |= (0x001 << 19);
    if (VList.includes('OptionImages'))
      LayoutConfiguration |= (0x001 << 20);
    if (VList.includes('TwoLevelGroup'))
      LayoutConfiguration |= (0x001 << 21);
    ECV.LayoutConfiguration = LayoutConfiguration; // Need to add this to generation
    await this.setState({ LayoutConfiguration });
  }
  // Convert Encoded Bit-Values For LayoutConfiguration
  // ** Add to saveRecord  await this.getLayoutConfigurationBitEncoded()
  getLayoutConfigurationBitEncoded = async () => {
    let LayoutConfiguration = 0x0000000000000000;
    if (this.state.HasLandingPage === true)
      LayoutConfiguration |= (0x001 << 1);
    if (this.state.HasLocationInfo === true)
      LayoutConfiguration |= (0x001 << 2);
    if (this.state.HasBackgroundMenuImage === true)
      LayoutConfiguration |= (0x001 << 3);
    if (this.state.UseMenuLayout1 === true)
      LayoutConfiguration |= (0x001 << 4);
    if (this.state.UseMenuLayout2 === true)
      LayoutConfiguration |= (0x001 << 5);
    if (this.state.UseMenuLayout3 === true)
      LayoutConfiguration |= (0x001 << 6);
    if (this.state.UseMenuLayout4 === true)
      LayoutConfiguration |= (0x001 << 7);
    if (this.state.UseMenuLayout5 === true)
      LayoutConfiguration |= (0x001 << 8);
    if (this.state.UseMenuLayout6 === true)
      LayoutConfiguration |= (0x001 << 9);
    if (this.state.UseMenuLayout7 === true)
      LayoutConfiguration |= (0x001 << 10);
    if (this.state.UseMenuLayout8 === true)
      LayoutConfiguration |= (0x001 << 11);
    if (this.state.HasGroupMenus === true)
      LayoutConfiguration |= (0x001 << 15);
    if (this.state.RetailConfiguration === true)
      LayoutConfiguration |= (0x001 << 16);
    if (this.state.DropBoxBorders === true)
      LayoutConfiguration |= (0x001 << 17);
    if (this.state.WideSpacing === true)
      LayoutConfiguration |= (0x001 << 18);
    if (this.state.CategoryImages === true)
      LayoutConfiguration |= (0x001 << 19);
    if (this.state.OptionImages === true)
      LayoutConfiguration |= (0x001 << 20);
    if (this.state.TwoLevelGroup === true)
      LayoutConfiguration |= (0x001 << 21);
    ECV.LayoutConfiguration = LayoutConfiguration; // Need to add this to generation
    await this.setState({ LayoutConfiguration });
  }
  // Set State Variables for Encoded Bit-Values For LayoutConfiguration
  // ** Add to getRecord  await this.setLayoutConfigurationBitEncoded(row[elem.n])
  setLayoutConfigurationBitEncoded = async (LayoutConfigurationVals) => {
    if ((LayoutConfigurationVals & (0x001 << 1)) === (0x001 << 1))
      this.setState({ HasLandingPage: true });
    else
      this.setState({ HasLandingPage: false });
    if ((LayoutConfigurationVals & (0x001 << 2)) === (0x001 << 2))
      this.setState({ HasLocationInfo: true });
    else
      this.setState({ HasLocationInfo: false });
    if ((LayoutConfigurationVals & (0x001 << 3)) === (0x001 << 3))
      this.setState({ HasBackgroundMenuImage: true });
    else
      this.setState({ HasBackgroundMenuImage: false });
    if ((LayoutConfigurationVals & (0x001 << 4)) === (0x001 << 4))
      this.setState({ UseMenuLayout1: true });
    else
      this.setState({ UseMenuLayout1: false });
    if ((LayoutConfigurationVals & (0x001 << 5)) === (0x001 << 5))
      this.setState({ UseMenuLayout2: true });
    else
      this.setState({ UseMenuLayout2: false });
    if ((LayoutConfigurationVals & (0x001 << 6)) === (0x001 << 6))
      this.setState({ UseMenuLayout3: true });
    else
      this.setState({ UseMenuLayout3: false });
    if ((LayoutConfigurationVals & (0x001 << 7)) === (0x001 << 7))
      this.setState({ UseMenuLayout4: true });
    else
      this.setState({ UseMenuLayout4: false });
    if ((LayoutConfigurationVals & (0x001 << 8)) === (0x001 << 8))
      this.setState({ UseMenuLayout5: true });
    else
      this.setState({ UseMenuLayout5: false });
    if ((LayoutConfigurationVals & (0x001 << 9)) === (0x001 << 9))
      this.setState({ UseMenuLayout6: true });
    else
      this.setState({ UseMenuLayout6: false });
    if ((LayoutConfigurationVals & (0x001 << 10)) === (0x001 << 10))
      this.setState({ UseMenuLayout7: true });
    else
      this.setState({ UseMenuLayout7: false });
    if ((LayoutConfigurationVals & (0x001 << 11)) === (0x001 << 11))
      this.setState({ UseMenuLayout8: true });
    else
      this.setState({ UseMenuLayout8: false });
    if ((LayoutConfigurationVals & (0x001 << 15)) === (0x001 << 15))
      this.setState({ HasGroupMenus: true });
    else
      this.setState({ HasGroupMenus: false });
    if ((LayoutConfigurationVals & (0x001 << 16)) === (0x001 << 16))
      this.setState({ RetailConfiguration: true });
    else
      this.setState({ RetailConfiguration: false });
    if ((LayoutConfigurationVals & (0x001 << 17)) === (0x001 << 17))
      this.setState({ DropBoxBorders: true });
    else
      this.setState({ DropBoxBorders: false });
    if ((LayoutConfigurationVals & (0x001 << 18)) === (0x001 << 18))
      this.setState({ WideSpacing: true });
    else
      this.setState({ WideSpacing: false });
    if ((LayoutConfigurationVals & (0x001 << 19)) === (0x001 << 19))
      this.setState({ CategoryImages: true });
    else
      this.setState({ CategoryImages: false });
    if ((LayoutConfigurationVals & (0x001 << 20)) === (0x001 << 20))
      this.setState({ OptionImages: true });
    else
      this.setState({ OptionImages: false });
    if ((LayoutConfigurationVals & (0x001 << 21)) === (0x001 << 21))
      this.setState({ TwoLevelGroup: true });
    else
      this.setState({ TwoLevelGroup: false });
  }
  // Clear State Variables for Encoded Bit-Values For LayoutConfiguration
  // ** Add to clearRecord  await this.clearLayoutConfigurationBitEncoded()
  clearLayoutConfigurationBitEncoded = async () => {
    this.setState({ HasLandingPage: false });
    this.setState({ HasLocationInfo: false });
    this.setState({ HasBackgroundMenuImage: false });
    this.setState({ UseMenuLayout1: false });
    this.setState({ UseMenuLayout2: false });
    this.setState({ UseMenuLayout3: false });
    this.setState({ UseMenuLayout4: false });
    this.setState({ UseMenuLayout5: false });
    this.setState({ UseMenuLayout6: false });
    this.setState({ UseMenuLayout7: false });
    this.setState({ UseMenuLayout8: false });
    this.setState({ HasGroupMenus: false });
    this.setState({ RetailConfiguration: false });
    this.setState({ DropBoxBorders: false });
    this.setState({ WideSpacing: false });
    this.setState({ CategoryImages: false });
    this.setState({ OptionImages: false });
    this.setState({ TwoLevelGroup: false });
  }
  //--------------------------------------------------------------------------------------------------------------------------------------
  //------ Function Code - CheckoutControls ------
  // Convert Encoded Values For InteractControls
  // Add to saveRecord  await getInteractControlsEncoded()
  getInteractControlsEncoded = async () => {
    let InteractControls = 0x0000000000000000;
    let VList = this.state.InteractControlsVals;
    if (VList.includes('App Debug Mode'))
      InteractControls |= (0x0000000000000001 << 1);
    if (VList.includes('Time Of Day Control'))
      InteractControls |= (0x0000000000000001 << 2);
    if (VList.includes('Season Control'))
      InteractControls |= (0x0000000000000001 << 3);
    if (VList.includes('Day Of Week Control'))
      InteractControls |= (0x0000000000000001 << 4);
    if (VList.includes('Price Override Control'))
      InteractControls |= (0x0000000000000001 << 5);
    CCV.InteractControls = InteractControls;
    await this.setState({ InteractControls });
  }
  getBrandLogoImage = async (imageID) => {
    console.log(`getBrandLogoImage: ${imageID}`);
    const imageURL = await getImageFileFromServer(imageID);
    await this.setState({ BrandLogoImageURL: imageURL });
  }
  getBackgroundImage = async (imageID) => {
    console.log(`getBackgroundImage: ${imageID}`);
    const imageURL = await getImageFileFromServer(imageID,5);
    this.setState({ BackgroundImageURL: imageURL });
  }

  //------ Help Information -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  showHelp = async (key) => {
    if (this.state.showHelpListPopup == true) { // Close Help
      this.setState({ showHelpListPopup: false });
      this.setState({ showHelpDetail: false });
    } else {
      if (!key)
        key = '';
      this.setState({ showHelpDetail: false });
      let HelpPages = await getHelpTopics(key);
      //console.log("caller HelpPages: " + JSON.stringify(HelpPages));
      this.setState({ HelpPages });
      this.setState({ showHelpListPopup: true });
    }
  }
  closeHelpList = () => {
    this.setState({ showHelpListPopup: false });
  }
  onHelpItemClick = async (item) => {
    let helpDetail = await getHelpDetail(item.HelpPageID);
    this.setState({ helpDetail });
    this.setState({ showHelpDetail: true });
  }
  closeHelpTime = async () => {
    this.setState({ showHelpDetail: false });
  }
  onObjectHelp = async (objectID) => {
    let helpDetail = await getHelpDetail(objectID,2);
    this.setState({ helpDetail });
    this.setState({ showHelpDetail: true });
  }
  closeHelpTime = async () => {
    this.setState({ showHelpDetail: false });
  }
  // Help List Layout
  HelpPageHeader = () => {
    return (
      <ListViewHeader className='listHelpHeader' onClick={(e) => this.closeHelpList()} >
        <div className='listHeaderLeft' onClick={(e) => this.closeHelpList()}>
          <span className="listHelpTitle">{SessionInfo.HelpTitle}</span>
        </div>
        <div className='listHeaderRight' onClick={(e) => this.closeHelpList()}>
          <Button id="cancelButton" icon="cancel" look="outline" className="medButton" onClick={this.closeHelpList} >EXIT HELP</Button>
        </div>
      </ListViewHeader>
    );
  }
  HelpPageFormat = props => {
    let item = props.dataItem;
    return (
      <div>
        <div className="listHelpRow" onClick={(e) => this.onHelpItemClick(item)}>
          <div className="listColA">
            <span className="listHelpItemTitle" >{item.HelpTitle}&nbsp;&nbsp;&nbsp;</span>
            <div dangerouslySetInnerHTML={{ __html: item.HelpContent }}></div>
          </div>
        </div>
      </div>
    );
  }
  HelpPageFooter = () => {
    //const [state, onCheckout] = React.useContext(StateContext);
    return (
      <ListViewFooter className='listHelpFooter' onClick={(e) => this.closeHelpList()} >
        <div className='listHeaderRight' onClick={(e) => this.closeHelpList()}>
          <Button id="cancelButton" icon="cancel" look="outline" className="medButton" onClick={this.closeHelpList} >EXIT HELP</Button>
        </div>
      </ListViewFooter>
    );
  }
  ShowFieldHelp = async (key) => {
    console.log(`Field Help - Key: ${key}`);
    this.onObjectHelp(key);
    //this.showHelp(key);
    //console.log(`Field Help: ${JSON.stringify(item)}`);
  }
  //------ End of Help -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  //------------------------- Image Management ------------------------------
  //
  addCompanyLogoImage = async (event) => {
    try {
      const fileObj = event.affectedFiles[0].getRawFile();
      let imageType = getDocumentType(event.affectedFiles[0].extension,"Company Logo");
      let reader = new FileReader();
      reader.readAsArrayBuffer(fileObj);
      reader.onloadend = async () => {
        let imageFile = await Buffer.from(reader.result);
        this.setState({ CompanyLogoImageURL: URL.createObjectURL(fileObj) });
        let iVal = await saveImageFileToServer(imageFile,imageType,CompaniesOID,CV.CompanyID,488801); // Note CV.CompanyID rather than state.CompanyID - gets overwritten by get Entity
        this.setState({ CompanyLogo: iVal });
      }
      event.target.value = null;
    }
    catch (error) {
      console.log(`addCompanyLogoImage Error: ${error}`);
    }
  };
  addCompanyImage = async (event) => {
    try {
      const fileObj = event.affectedFiles[0].getRawFile();
      let imageType = getDocumentType(event.affectedFiles[0].extension,"Company Image");
      let reader = new FileReader();
      reader.readAsArrayBuffer(fileObj);
      reader.onloadend = async () => {
        let imageFile = await Buffer.from(reader.result);
        this.setState({ CompanyImageURL: URL.createObjectURL(fileObj) });
        let iVal = await saveImageFileToServer(imageFile,imageType,CompaniesOID,CV.CompanyID,555370); // Note CV.CompanyID rather than state.CompanyID - gets overwritten by get Entity
        this.setState({ CompanyImage: iVal });
      }
      event.target.value = null;
    }
    catch (error) {
      console.log(`addCompanyImage Error: ${error}`);
    }
  };
  addBrandLogoImage = async (event) => {
    try {
      const fileObj = event.affectedFiles[0].getRawFile();
      let imageType = getDocumentType(event.affectedFiles[0].extension,"Brand Photo");
      let reader = new FileReader();
      reader.readAsArrayBuffer(fileObj);
      reader.onloadend = async () => {
        let imageFile = await Buffer.from(reader.result);
        this.setState({ BrandLogoImageURL: URL.createObjectURL(fileObj) });
        let iVal = await saveImageFileToServer(imageFile,imageType,EntityConfigurationOID,this.state.EntityConfigurationID,547323);
        this.setState({ BrandLogo: iVal });
      }
      event.target.value = null;
    }
    catch (error) {
      console.log(`addBrandLogoImage Error: ${error}`);
    }
  };
  addBackgroundImage = async (event) => {
    try {
      const fileObj = event.affectedFiles[0].getRawFile();
      let imageType = getDocumentType(event.affectedFiles[0].extension,"Background Image");
      let reader = new FileReader();
      reader.readAsArrayBuffer(fileObj);
      reader.onloadend = async () => {
        let imageFile = await Buffer.from(reader.result);
        this.setState({ BackgroundImageURL: URL.createObjectURL(fileObj) });
        let iVal = await saveImageFileToServer(imageFile,imageType,EntityConfigurationOID,this.state.EntityConfigurationID,493869);
        this.setState({ BackgroundImage: iVal });
      }
      event.target.value = null;
    }
    catch (error) {
      console.log(`addBackgroundImage Error: ${error}`);
    }
  };
  onRemove = (event) => {
    console.log('onRemove: ',event.affectedFiles);
    this.setState({ files: event.newState });
  }
  onProgress = (event) => {
    console.log('onProgress: ',event.affectedFiles,event.serverResponse);
    this.setState({ files: event.newState });
  }
  onStatusChange = (event) => {
    //console.log('onStatusChange: ', event.affectedFiles, event.serverResponse);
    //console.log(`onStatusChange newState: ${JSON.stringify(event.newState)}`);
    //console.log(event.newState);
    let cnt = event.newState.length;
    event.newState[cnt - 1].status = 1;
    //console.log(event.newState);
    this.setState({ files: event.newState });
  }
  retrieveImage = async (iVal) => {
    console.log("Retrieve Image: " + iVal);
    await this.GetProductBrandLogImage(iVal);
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  deleteRecord = async () => {
    displayMessage("Cannot Delete Profile");
  }
  clearDefault = () => {
    displayMessage("Cannot Clear Profile");
  }
  searchDefault = () => {
    displayMessage("No Data to Search");
  }
  //------ Field Change Code - Companies ------  
  setItemStateChanged = (changed) => {
    this.setState({ itemStateHasChanged: changed });
    if (changed === true) {
      SessionInfo.setShowSave = 1; // Show Save in Header  
      if (this.clearScreen === true) {
        this.clearScreen = false;
        SessionInfo.setShowNew = 1;
      }
    } else
      SessionInfo.setShowSave = 2; // Turn Off
  }
  chgFldVal(event) {
    this.setState({ [event.target.name]: event.target.value });
    this.setItemStateChanged(true);
  }
  chgMoneyFldVal(event) {
    let newVal = event.target.value.replace(/[^\d.-]/g,'');
    this.setState({ [event.target.name]: newVal });
    this.setItemStateChanged(true);
  }
  chgPercentFldVal(event) {
    let newVal = event.target.value.replace(/[^\d.-]/g,'');
    newVal /= 100.0;
    this.setState({ [event.target.name]: newVal });
    this.setItemStateChanged(true);
  }
  chgDDFldVal = (event) => {
    this.setState({ [event.target.props.name]: event.target.value.ddID });
    this.setItemStateChanged(true);
  }
  chgDDFldValKey = (event) => {
    let key = event.target.value.k;
    let name = event.target.name;
    this.setState({ [name]: key });
    this.setItemStateChanged(true); 
    if (name.indexOf("Font") >= 0) 
      this.setFontInfo(name,key); 
  }
  setFontInfo(fieldName,key) {
    let cssVar = "--" + fieldName;
    if (fieldName.indexOf("Type") >= 0)
      document.documentElement.style.setProperty(cssVar,FontTypeValues[key - 1].n);
    else if (fieldName.indexOf("Size") >= 0)
      document.documentElement.style.setProperty(cssVar,FontSizeValues[key - 1].n);
    else // Wht
      document.documentElement.style.setProperty(cssVar,FontWhtValues[key - 1].n);
  }
  chgCheckboxVal(event) {
    let setVal = true;
    if (this.state[event.target.name] === true)
      setVal = false;
    this.setState({ [event.target.name]: setVal });
    this.setItemStateChanged(true);
    // Turn off all of the other Menu layout flags
    let name = event.target.name.substring(0,7);  //UseMenuLayout
    if (name === "UseMenu") {
      let num = event.target.name.substring(13,14);
      console.log(`name: ${event.target.name}, num: ${num}`);
      let n = parseInt(num);
      if (setVal === true) {
        if (n != 1)
          this.setState({ UseMenuLayout1: false });
        if (n != 2)
          this.setState({ UseMenuLayout2: false });
        if (n != 3)
          this.setState({ UseMenuLayout3: false });
        if (n != 4)
          this.setState({ UseMenuLayout4: false });
        if (n != 5)
          this.setState({ UseMenuLayout5: false });
        if (n != 6)
          this.setState({ UseMenuLayout6: false });
        if (n != 7)
          this.setState({ UseMenuLayout7: false });
        if (n != 8)
          this.setState({ UseMenuLayout8: false });
      }
    }
  }
  onChangeCompanyTypeID = (event) => {
    this.setState({ CompanyTypeIDVals: [...event.target.value] });
  }
  onChangeApplicationCnfg = (event) => {
    this.setState({
      ApplicationConfigurationVals: [...event.target.value]
    });
    this.setItemStateChanged(true);
  }
  onChangeLayoutCnfg = (event) => {
    this.setState({
      LayoutConfigurationVals: [...event.target.value]
    });
    this.setItemStateChanged(true);
  }
  onChangeInteractControls = (event) => {
    console.log(`Change InteractControls: ${event.target.value}, Vals: ${InteractControlVals}`);
    this.setState({
      InteractControlVals: [...event.target.value]
    });
    this.setItemStateChanged(true);
  }
  onChangeColor = (event,name) => {
    console.log(event);
    let hexValue = this.rgba2hex(event.value);
    console.log(`change color: ${name}, value: ${hexValue}`);
    //console.log(event);
    this.setState({ [name]: hexValue });
    this.setItemStateChanged(true);   
    this.setColorVar(name,hexValue); 
  };            
  setColorVar(name,colorVal) {
    let cssVar = '--' + name;        
    console.log(`change color: ${name}, xss: ${cssVar}, value: ${colorVal}`);
    document.documentElement.style.setProperty(cssVar,colorVal.trim()); 
  }
  rgba2hex = (rgba,forceRemoveAlpha = false) => {
    return "#" + rgba.replace(/^rgba?\(|\s+|\)$/g,'') // Get's rgba / rgb string values
      .split(',') // splits them at ","
      .filter((string,index) => !forceRemoveAlpha || index !== 3)
      .map(string => parseFloat(string)) // Converts them to numbers
      .map((number,index) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
      .map(number => number.toString(16)) // Converts numbers to hex
      .map(string => string.length === 1 ? "0" + string : string) // Adds 0 when length of one number is 1
      .join("") // Puts the array to togehter to a string
  }

  render() {
    return (
      <div>
        <div id="SettingsPage" className="pageMain">
          <PageSide />
          <PageHeader L1='Home' PageTitle='Setup Application' IsApp='y' />
          <div id="mainCntr">
            <TabStrip selected={this.state.selectedTopTab} onSelect={this.handleTopTabSelect} className="tabStrip">
              <TabStripTab title="Company Info">
                <div className="editTabLeftNarrow">
                  <h3> &nbsp; &nbsp;Company Information </h3>
                  <br />
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Company Name</span>
                    <input value={this.state.CompanyName} name='CompanyName' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Company Code</span>
                    <input value={this.state.CompanyCode} name='CompanyCode' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Legal Name</span>
                    <input value={this.state.CompanyLegalName} name='CompanyLegalName' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Account Number</span>
                    <input value={this.state.AccountNumber} name='AccountNumber' onChange={evt => this.chgFldVal(evt)} className='editInput' readonly={true} />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Account Start Date</span>
                    <div className='editDDPos'>
                      <DateTimePicker value={new Date(this.state.AccountStartDate)} name='AccountStartDate' onChange={evt => this.chgFldVal(evt)} className='editDateInput' />
                    </div>
                  </div>
                  {/*<div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Company Type</span>
                    <div className='editDDPos'>
                      <MultiSelect data={CompanyTypeIDList} value={this.state.CompanyTypeIDVals} name='CompanyTypeID' onChange={this.onChangeCompanyTypeID} className='editInputDD' />
                    </div>
                  </div>*/}
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Company Status</span>
                    <div className='editDDPos'>
                      <DropDownList data={this.state.CompanyStatusDict} textField='ddName' dataItemKey='ddID' value={this.state.CompanyStatusDict.find(c => c.ddID === this.state.CompanyStatusID)} name='CompanyStatusID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />
                    </div>
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Company Admin</span>
                    <input value={this.state.CompanyUserName} name='CompanyUserName' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                  </div>
                  <div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Description</span>
                    <textarea value={this.state.Description} name='Description' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                  </div>
                  <div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Comments</span>
                    <textarea value={this.state.Comments} name='Comments' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                  </div>
                  {(SessionInfo.PermLevel >= 499) ?
                    <>
                      <div id='div2' className='editField'>
                        <span className='editFieldLabel'>Company ID</span>
                        <input value={this.state.AppEntityID} name='AppEntityID' onChange={evt => this.chgFldVal(evt)} readOnly={true} className='editNumInputRO' />
                      </div>
                      <div id='div2' className='editField'>
                        <span className='editFieldLabel'>App Level</span>
                        <input value={this.state.ApplicationTypeID} name='ApplicationTypeID' onChange={evt => this.chgFldVal(evt)} className='editNumShortInputRO' />
                      </div>
                    </> : null}
                  {/*  <div id='div2' className='editField'>*/}
                  {/*    <span className='editFieldLabel'>Parent Company</span>*/}
                  {/*    <div className='editDDPos'>*/}
                  {/*      <DropDownList data={this.state.CompaniesDict} textField='ddName' dataItemKey='ddID' value={this.state.CompaniesDict.find(c => c.ddID === this.state.ParentCompanyID)} name='ParentCompanyID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' readOnly='{true}' />*/}
                  {/*    </div>*/}
                  {/*  </div>*/}
                </div>
                <div className="editTabMiddle">
                  <div id="div1" className="editInside">
                    <h3>Contact Information</h3>
                    <br />
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Primary Email</span>
                      <input value={this.state.MainEmailAddress} name='MainEmailAddress' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Primary Contact</span>
                      <input value={this.state.PrimeContactName} name='PrimeContactName' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Business Phone</span>
                      <input value={this.state.MainBusinessPhone} name='MainBusinessPhone' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Fax Number</span>
                      <input value={this.state.FaxNumber} name='FaxNumber' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Toll Free Number</span>
                      <input value={this.state.TollFreeNumber} name='TollFreeNumber' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Contact Cell Number</span>
                      <input value={this.state.MainCellNumber} name='MainCellNumber' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Alternate Cell</span>
                      <input value={this.state.AlternatePhoneNumber} name='AlternatePhoneNumber' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Web Site</span>
                      <textarea value={this.state.WebSite} name='WebSite' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                    </div>
                    <br />
                    <br />
                    <h3>Taxes</h3>
                    <br />
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Main Tax Number</span>
                      <input value={this.state.TAXNumber} name='TAXNumber' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Second Tax Number</span>
                      <input value={this.state.TAX2Number} name='TAX2Number' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>DUNS Number</span>
                      <input value={this.state.DUNSNumber} name='DUNSNumber' onChange={evt => this.chgFldVal(evt)} className='editInputMedium' />
                    </div>
                  </div>
                </div>
                <div className="editTabRightNarrow">
                  <div id="div1" className="editInside">
                    <h3>Address</h3>
                    <br />
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Unit Number</span>
                      <input value={this.state.UnitNumber} name='UnitNumber' onChange={evt => this.chgFldVal(evt)} className='editInputMedium' />
                    </div>
                    <div id='div2' className='editTAField'>
                      <span className='editFieldLabel'>Address</span>
                      <textarea value={this.state.Address} name='Address' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>City</span>
                      <input value={this.state.City} name='City' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>State/Province</span>
                      <div className='editDDPos'>
                        <DropDownList data={this.state.ProvinceStateCodesDict} textField='ddName' dataItemKey='ddID' value={this.state.ProvinceStateCodesDict.find(c => c.ddID === this.state.ProvinceStateID)} name='ProvinceStateID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Zip/Postal Code</span>
                      <input value={this.state.PostalCode} name='PostalCode' onChange={evt => this.chgFldVal(evt)} className='editInputMedium' />
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Country</span>
                      <div className='editDDPos'>
                        <DropDownList data={this.state.CountriesDict} textField='ddName' dataItemKey='ddID' value={this.state.CountriesDict.find(c => c.ddID === this.state.CountryID)} name='CountryID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />
                      </div>
                    </div>
                    {/*  <div id='div2' className='editField'>*/}
                    {/*    <span className='editFieldLabel'>Sales Group</span>*/}
                    {/*    <div className='editDDPos'>*/}
                    {/*      <DropDownList data={this.state.SalesGroupsDict} textField='ddName' dataItemKey='ddID' value={this.state.SalesGroupsDict.find(c => c.ddID === this.state.SalesGroupID)} name='SalesGroupID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*  <div id='div2' className='editField'>*/}
                    {/*    <span className='editFieldLabel'>Sales Person</span>*/}
                    {/*    <div className='editDDPos'>*/}
                    {/*      <DropDownList data={this.state.ResourcesDict} textField='ddName' dataItemKey='ddID' value={this.state.ResourcesDict.find(c => c.ddID === this.state.SalesPersonID)} name='SalesPersonID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*  <div id='div2' className='editField'>*/}
                    {/*    <span className='editFieldLabel'>Invoice Group</span>*/}
                    {/*    <div className='editDDPos'>*/}
                    {/*      <DropDownList data={this.state.InvoiceGroupsDict} textField='ddName' dataItemKey='ddID' value={this.state.InvoiceGroupsDict.find(c => c.ddID === this.state.InvoiceGroupID)} name='InvoiceGroupID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*  <div id='div2' className='editField'>*/}
                    {/*    <span className='editFieldLabel'>Month Period Type</span>*/}
                    {/*    <div className='editDDPos'>*/}
                    {/*      <DropDownList data={this.state.MonthPeriodTypes} textField='ddName' dataItemKey='ddID' value={this.state.MonthPeriodTypes.find(c => c.ddID === this.state.MonthPeriodType)} name='MonthPeriodType' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*  <div id='div2' className='editField'>*/}
                    {/*    <span className='editFieldLabel'>Current Month End</span>*/}
                    {/*    <div className='editDDPos'>*/}
                    {/*      <DateTimePicker value={new Date(this.state.CurrentMonthEnd)} name='CurrentMonthEnd' onChange={evt => this.chgFldVal(evt)} className='editDateInput' />*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*  <div id='div2' className='editField'>*/}
                    {/*    <span className='editFieldLabel'>Company Logo</span>*/}
                    {/*  </div>*/}
                  </div>

                </div>
              </TabStripTab>
              <TabStripTab title="Settings">
                <div className="editTabLeftNarrow">
                  <h3> &nbsp; &nbsp;Company Controls </h3>
                  <br />
                  {/*<div id='div2' className='editField'>
                    <span className='editFieldLabel'>Checkout Control</span>
                    <div className='editDDPos'>
                      <DropDownList data={this.state.CheckoutControlsDict} textField='ddName' dataItemKey='ddID' value={this.state.CheckoutControlsDict.find(c => c.ddID === this.state.CheckoutControlID)} name='CheckoutControlID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />
                    </div>
                  </div>*/}
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Hold Problem Days</span>
                    <input value={this.state.HoldProblemDays} name='HoldProblemDays' onChange={evt => this.chgFldVal(evt)} className='editNumShortInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Hold Abandoned Days</span>
                    <input value={this.state.HoldAbandonedDays} name='HoldAbandonedDays' onChange={evt => this.chgFldVal(evt)} className='editNumShortInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Max Months For Receipts</span>
                    <input value={this.state.MaxMonthsForReceipts} name='MaxMonthsForReceipts' onChange={evt => this.chgFldVal(evt)} className='editNumShortInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Maximum Store Count</span>
                    <input value={this.state.MaximumStoreCount} name='MaximumStoreCount' readOnly={true} className='editNumShortInputRO' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Maximum Product Count</span>
                    <input value={this.state.MaximumProductCount} name='MaximumProductCount' readOnly={true} className='editNumShortInputRO' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Maximum User Count</span>
                    <input value={this.state.MaximumUserCount} name='MaximumUserCount' readOnly={true} className='editNumShortInputRO' />
                  </div>
                  <br />
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Payment Proc Type</span>
                    <input value={this.state.PaymentProcTypeID} name='PaymentProcTypeID' onChange={evt => this.chgFldVal(evt)} className='editNumShortInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Payment Proc</span>
                    <input value={this.state.PaymentProcID} name='PaymentProcID' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Payment Proc Key 1</span>
                    <input value={this.state.PaymentProcKey1} name='PaymentProcKey1' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Payment Proc Key 2</span>
                    <input value={this.state.PaymentProcKey2} name='PaymentProcKey2' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Payment Proc Key 3</span>
                    <input value={this.state.PaymentProcKey3} name='PaymentProcKey3' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Payment Proc Version</span>
                    <input value={this.state.PaymentProcVersion} name='PaymentProcVersion' onChange={evt => this.chgFldVal(evt)} className='editInputMedium' />
                  </div>
                  <br />
                  {/*<div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Interact Controls</span>
                    <div className='editDDPos'>
                      <MultiSelect data={InteractControlsList} value={this.state.InteractControlsVals} name='InteractControls' onChange={this.onChangeInteractControls} className='editInputDD' />
                    </div>
                  </div>*/}

                  {/*------ Encoded Bit Values using Switch Control - CheckoutControls ------*/}
                  <h3> &nbsp; &nbsp;Menu Controls </h3>
                  <br />
                  <div id="div2" className="editField">
                    <Switch checked={this.state.AppDebugMode} name="AppDebugMode" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; App Debug Mode</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.TimeOfDayControl} name="TimeOfDayControl" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Time Of Day Control</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.SeasonControl} name="SeasonControl" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Season Control</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.DayOfWeekControl} name="DayOfWeekControl" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Day Of Week Control</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.PriceOverrideControl} name="PriceOverrideControl" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Price Override Control</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.ControlInventory} name="ControlInventory" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Control Inventory</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.OrderingControl} name="OrderingControl" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Ordering Control</span>
                  </div>
                </div>
                <div className="editTabMiddle">
                  <h3>Application Messages</h3>
                  <br />
                  <div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Greeting Message</span>
                    <textarea value={this.state.GreetingMessage} name='GreetingMessage' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                  </div>
                  <div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Second Message</span>
                    <textarea value={this.state.SecondMessage} name='SecondMessage' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                  </div>
                  <br />
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Store Promotion</span>
                    <div className='editDDPos'>
                      <DropDownList data={this.state.StorePromotionsDict} textField='ddName' dataItemKey='ddID' value={this.state.StorePromotionsDict.find(c => c.ddID === this.state.StorePromotionID)} name='StorePromotionID' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />
                    </div>
                  </div>
                  <div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Promo1 Link</span>
                    <textarea value={this.state.Promo1Link} name='Promo1Link' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Second Promo </span>
                    <div className='editDDPos'>
                      <DropDownList data={this.state.StorePromotionsDict} textField='ddName' dataItemKey='ddID' value={this.state.StorePromotionsDict.find(c => c.ddID === this.state.StorePromotion2)} name='StorePromotion2' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />
                    </div>
                  </div>
                  <div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Promo2 Link</span>
                    <textarea value={this.state.Promo2Link} name='Promo2Link' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Third Promo</span>
                    <div className='editDDPos'>
                      <DropDownList data={this.state.StorePromotionsDict} textField='ddName' dataItemKey='ddID' value={this.state.StorePromotionsDict.find(c => c.ddID === this.state.StorePromotion3)} name='StorePromotion3' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />
                    </div>
                  </div>
                  <div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Promo3 Link</span>
                    <textarea value={this.state.Promo3Link} name='Promo3Link' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Fourth Promo</span>
                    <div className='editDDPos'>
                      <DropDownList data={this.state.StorePromotionsDict} textField='ddName' dataItemKey='ddID' value={this.state.StorePromotionsDict.find(c => c.ddID === this.state.StorePromotion4)} name='StorePromotion4' onChange={evt => this.chgDDFldVal(evt)} className='editInputDD' />
                    </div>
                  </div>
                  <div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Promo4 Link</span>
                    <textarea value={this.state.Promo4Link} name='Promo4Link' onChange={evt => this.chgFldVal(evt)} className='editTAInput' />
                  </div>
                </div>
                <div className="editTabRightNarrow">
                  <h3>Application Control</h3>
                  <br />
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Default Location</span>
                    <div className="editDDPos">
                      <DropDownList data={this.state.StoreLocationsDict} textField="ddName" dataItemKey="ddID" value={this.state.StoreLocationsDict.find(c => c.ddID === this.state.DefaultStoreLocationID)} name="DefaultStoreLocationID" onChange={evt => this.chgDDFldVal(evt)} className="editInputDD" />
                    </div>
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Default Order Type</span>
                    <div className="editDDPos">
                      <DropDownList data={this.state.OrderTypesDict} textField="ddName" dataItemKey="ddID" value={this.state.OrderTypesDict.find(c => c.ddID === this.state.DefaultOrderType)} name="DefaultOrderType" onChange={evt => this.chgDDFldVal(evt)} className="editInputDD" />
                    </div>
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Start Of Week</span>
                    <div className="editDDPos">
                      <DropDownList data={DaysOfWeekFixedValues} textField="n" dataItemKey="k" value={DaysOfWeekFixedValues.find(c => c.k === this.state.BaseDayOfWeek)} name="BaseDayOfWeek" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDD" />
                    </div>
                  </div>
                  <br />
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Tax1 Percent</span>
                    <input value={this.state.Tax1Percent} name='Tax1Percent' onChange={evt => this.chgPercentFldVal(evt)} className='editNumShortInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Tax2 Percent</span>
                    <input value={this.state.Tax2Percent} name='Tax2Percent' onChange={evt => this.chgPercentFldVal(evt)} className='editNumShortInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Tax3 Percent</span>
                    <input value={this.state.Tax3Percent} name='Tax3Percent' onChange={evt => this.chgPercentFldVal(evt)} className='editNumShortInput' />
                  </div>
                  <br />
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Geo Fence Meters</span>
                    <input value={this.state.GeoFenceMeters} name='GeoFenceMeters' onChange={evt => this.chgFldVal(evt)} className='editNumShortInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>Registration Code</span>
                    <input value={this.state.RegistrationCode} name='RegistrationCode' onChange={evt => this.chgFldVal(evt)} className='editInput' />
                  </div>
                  <div id='div2' className='editField'>
                    <span className='editFieldLabel'>LastUpdatedOn</span>
                    <div className='editDDPos'>
                      <DateTimePicker value={new Date(this.state.LastUpdatedOn)} name='LastUpdatedOn' onChange={evt => this.chgFldVal(evt)} className='editDateInput' />
                    </div>
                  </div>
                </div>
              </TabStripTab>
              <TabStripTab title="Configuration">
                <div className="editTabLeftExNarrow">
                  {/*<br />
                  <div id='div2' className='editTAField'>
                    <span className='editFieldLabel'>Layout Config</span>
                    <div className='editDDPos'>
                      <MultiSelect data={LayoutConfigurationList} value={this.state.LayoutConfigurationVals} name='LayoutConfiguration' onChange={this.onChangeLayoutCnfg} className='editInputDD' />
                    </div>
                  </div>*/}
                  <h2> &nbsp; Appearance and Layout </h2>
                  <br />
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasLandingPage} name="HasLandingPage" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Landing Page</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasLocationInfo} name="HasLocationInfo" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Location Info</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasBackgroundMenuImage} name="HasBackgroundMenuImage" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Background Menu Image</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.UseMenuLayout1} name="UseMenuLayout1" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Use Menu Layout 1</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.UseMenuLayout2} name="UseMenuLayout2" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Use Menu Layout 2</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.UseMenuLayout3} name="UseMenuLayout3" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Use Menu Layout 3</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.UseMenuLayout4} name="UseMenuLayout4" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Use Menu Layout 4</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.UseMenuLayout5} name="UseMenuLayout5" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Use Menu Layout 5</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.UseMenuLayout6} name="UseMenuLayout6" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Use Menu Layout 6</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.UseMenuLayout7} name="UseMenuLayout7" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Use Menu Layout 7</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.UseMenuLayout8} name="UseMenuLayout8" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Use Menu Layout 8</span>
                  </div>
                  {/*<div id="div2" className="editField">*/}
                  {/*  <Switch checked={this.state.UseMenuLayout7} name="UseMenuLayout7" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; User Menu Layout 7</span>*/}
                  {/*</div>*/}
                  {/*<div id="div2" className="editField">*/}
                  {/*  <Switch checked={this.state.UseMenuLayout8} name="UseMenuLayout8" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Use Menu Layout 8</span>*/}
                  {/*</div>*/}
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasGroupMenus} name="HasGroupMenus" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Group Menus</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.RetailConfiguration} name="RetailConfiguration" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Retail Configuration</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.DropBoxBorders} name="DropBoxBorders" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Drop Box Borders</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.WideSpacing} name="WideSpacing" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Wide Spacing</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.CategoryImages} name="CategoryImages" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Category Images</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.OptionImages} name="OptionImages" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Option Images</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.TwoLevelGroup} name="TwoLevelGroup" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Two Level Group</span>
                  </div>
                  <br />
                  <h4> &nbsp; Brand Color</h4>
                  <br />
                  <div id='div2' className='editTAXField'>
                    <span className='editFieldLabel'>Page Heading Color</span>
                    <div className='editTAColorInput'>
                      <div style={{ color: this.state.BrandColor }}>
                        {this.state.BrandColor}
                      </div>
                      <ColorPicker name='BrandColor' view={"combo"} value={this.state.BrandColor} onChange={(evt) => { this.onChangeColor(evt,'BrandColor'); }} />
                    </div>
                  </div>
                  <br />
                  <div id='div2' className='editTAXField'>
                    <span className='editFieldLabel'>Promotion Color</span>
                    <div className='editTAColorInput'>
                      <div style={{ color: this.state.PromoColor }}>
                        {this.state.PromoColor}
                      </div>
                      <ColorPicker name='PromoColor' view={"combo"} value={this.state.PromoColor} onChange={(evt) => { this.onChangeColor(evt,'PromoColor'); }} />
                    </div>
                  </div>
                  <div id='div2' className='editTAXField'>
                    <span className='editFieldLabel'>Cart Color</span>
                    <div className='editTAColorInput'>
                      <div style={{ color: this.state.CartColor }}>
                        {this.state.CartColor}
                      </div>
                      <ColorPicker name='CartColor' view={"combo"} value={this.state.CartColor} onChange={(evt) => { this.onChangeColor(evt,'CartColor'); }} />
                    </div>
                  </div>
                  <div id='div2' className='editTAXField'>
                    <span className='editFieldLabel'>Purchased Color</span>
                    <div className='editTAColorInput'>
                      <div style={{ color: this.state.PurchasedColor }}>
                        {this.state.PurchasedColor}
                      </div>
                      <ColorPicker name='PurchasedColor' view={"combo"} value={this.state.PurchasedColor} onChange={(evt) => { this.onChangeColor(evt,'PurchasedColor'); }} />
                    </div>
                  </div>
                </div>
                <div className="editTabMiddleLeft">
                  <div id="div1" className="editInside">
                    <h2> &nbsp; Menu App Colors</h2>
                    <br />
                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Input Text Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.InputTextColor }}>
                          {this.state.InputTextColor}
                        </div>
                        <ColorPicker name='InputTextColor' view={"combo"} value={this.state.InputTextColor} onChange={(evt) => { this.onChangeColor(evt,'InputTextColor'); }} /> 
                      </div>
                    </div>
                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Input BG Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.InputBGColor }}>
                          {this.state.InputBGColor}
                        </div>
                        <ColorPicker name='InputBGColor' view={"combo"} value={this.state.InputBGColor} onChange={(evt) => { this.onChangeColor(evt,'InputBGColor'); }} />
                      </div>
                    </div>
                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Input Border Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.InputBorderColor }}>
                          {this.state.InputBorderColor}
                        </div>
                        <ColorPicker name='InputBorderColor' view={"combo"} value={this.state.InputBorderColor} onChange={(evt) => { this.onChangeColor(evt,'InputBorderColor'); }} />
                      </div>
                    </div>

                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Heading Text Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.HeadingTextColor }}>
                          {this.state.HeadingTextColor}
                        </div>
                        <ColorPicker name='HeadingTextColor' view={"combo"} value={this.state.HeadingTextColor} onChange={(evt) => { this.onChangeColor(evt,'HeadingTextColor'); }} />
                      </div>
                    </div>

                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Button Text Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.ButtonTextColor }}>
                          {this.state.ButtonTextColor}
                        </div>
                        <ColorPicker name='ButtonTextColor' view={"combo"} value={this.state.ButtonTextColor} onChange={(evt) => { this.onChangeColor(evt,'ButtonTextColor'); }} />
                      </div>
                    </div>
                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Button BG Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.ButtonBGColor }}>
                          {this.state.ButtonBGColor}
                        </div>
                        <ColorPicker name='ButtonBGColor' view={"combo"} value={this.state.ButtonBGColor} onChange={(evt) => { this.onChangeColor(evt,'ButtonBGColor'); }} />
                      </div>
                    </div>

                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Item Name Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.ItemNameColor }}>
                          {this.state.ItemNameColor}
                        </div>
                        <ColorPicker name='ItemNameColor' view={"combo"} value={this.state.ItemNameColor} onChange={(evt) => { this.onChangeColor(evt,'ItemNameColor'); }} />
                      </div>
                    </div>
                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Item Desc Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.ItemDescColor }}>
                          {this.state.ItemDescColor}
                        </div>
                        <ColorPicker name='ItemDescColor' view={"combo"} value={this.state.ItemDescColor} onChange={(evt) => { this.onChangeColor(evt,'ItemDescColor'); }} />
                      </div>
                    </div>

                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>List BG Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.ListBGColor }}>
                          {this.state.ListBGColor}
                        </div>
                        <ColorPicker name='ListBGColor' view={"combo"} value={this.state.ListBGColor} onChange={(evt) => { this.onChangeColor(evt,'ListBGColor'); }} />
                      </div>
                    </div>

                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>List Head Text Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.ListHeadTextColor }}>
                          {this.state.ListHeadTextColor}
                        </div>
                        <ColorPicker name='ListHeadTextColor' view={"combo"} value={this.state.ListHeadTextColor} onChange={(evt) => { this.onChangeColor(evt,'ListHeadTextColor'); }} />
                      </div>
                    </div>
                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>List Head BG Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.ListHeadBGColor }}>
                          {this.state.ListHeadBGColor}
                        </div>
                        <ColorPicker name='ListHeadBGColor' view={"combo"} value={this.state.ListHeadBGColor} onChange={(evt) => { this.onChangeColor(evt,'ListHeadBGColor'); }} />
                      </div>
                    </div>

                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Section Text Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.ListSectionTextColor }}>
                          {this.state.ListSectionTextColor}
                        </div>
                        <ColorPicker name='ListSectionTextColor' view={"combo"} value={this.state.ListSectionTextColor} onChange={(evt) => { this.onChangeColor(evt,'ListSectionTextColor'); }} />
                      </div>
                    </div>
                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>List Section BG Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.ListSectionBGColor }}>
                          {this.state.ListSectionBGColor}
                        </div>
                        <ColorPicker name='ListSectionBGColor' view={"combo"} value={this.state.ListSectionBGColor} onChange={(evt) => { this.onChangeColor(evt,'ListSectionBGColor'); }} />
                      </div>
                    </div>
                    {/* --- For Future Use ---
                    <div id='div2' className='editTAXField'>
                      <span className='editFieldLabel'>Prompt Color</span>
                      <div className='editTAColorInput'>
                        <div style={{ color: this.state.PromptColor }}>
                          {this.state.PromptColor}
                        </div>
                        <ColorPicker name='PromptColor' view={"combo"} value={this.state.PromptColor} onChange={(evt) => { this.onChangeColor(evt,'PromptColor'); }} />
                      </div>
                    </div>
                    */}

                  </div>
                </div>
                {/*--------------------------------------------------------------------*/}
                <div className="editTabMiddleRight">
                  <div id="div1" className="editInside">
                    <h2> &nbsp; Menu App Fonts</h2>
                    <br />
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Input Text</span>
                      <div className='editDDPosL'>
                        <DropDownList data={FontTypeValues} textField="n" dataItemKey="k" value={FontTypeValues.find(c => c.k === this.state.InputFontType)} name="InputFontType" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVShort" />
                      </div>
                      <div className="editDDPosM">
                        <DropDownList data={FontSizeValues} textField="n" dataItemKey="k" value={FontSizeValues.find(c => c.k === this.state.InputFontSize)} name="InputFontSize" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Sample</span>
                      <input value={this.state.InputTextSample} name='InputTextSample' onChange={evt => this.chgFldVal(evt)} className='InputTextSampleCSS' />
                    </div>

                    <div style={{ height: '160px',minHeight: '160px' }}>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Heading</span>
                      <div className='editDDPosL'>
                        <DropDownList data={FontTypeValues} textField="n" dataItemKey="k" value={FontTypeValues.find(c => c.k === this.state.HeadingFontType)} name="HeadingFontType" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVShort" />
                      </div>
                      <div className="editDDPosM">
                        <DropDownList data={FontSizeValues} textField="n" dataItemKey="k" value={FontSizeValues.find(c => c.k === this.state.HeadingFontSize)} name="HeadingFontSize" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Sample</span>
                      <input value={this.state.HeadingSample} name='HeadingSample' onChange={evt => this.chgFldVal(evt)} className='HeadingSampleCSS' />
                    </div>
                    <div style={{ height: '7px',minHeight: '7px' }}>
                    </div>

                    <div style={{ height: '8px',minHeight: '8px' }}>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Button</span>
                      <div className='editDDPosL'>
                        <DropDownList data={FontTypeValues} textField="n" dataItemKey="k" value={FontTypeValues.find(c => c.k === this.state.ButtonFontType)} name="ButtonFontType" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVShort" />
                      </div>
                      <div className="editDDPosM">
                        <DropDownList data={FontSizeValues} textField="n" dataItemKey="k" value={FontSizeValues.find(c => c.k === this.state.ButtonFontSize)} name="ButtonFontSize" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Sample</span>
                      <input value={this.state.ButtonSample} name='ButtonSample' onChange={evt => this.chgFldVal(evt)} className='ButtonSampleCSS' />
                    </div>

                    <div style={{ height: '78px',minHeight: '78px' }}>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Name</span>
                      <div className='editDDPosL'>
                        <DropDownList data={FontTypeValues} textField="n" dataItemKey="k" value={FontTypeValues.find(c => c.k === this.state.ItemNameFontType)} name="ItemNameFontType" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVShort" />
                      </div>
                      <div className="editDDPosM">
                        <DropDownList data={FontSizeValues} textField="n" dataItemKey="k" value={FontSizeValues.find(c => c.k === this.state.ItemNameFontSize)} name="ItemNameFontSize" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                      <div className="editDDPosR">
                        <DropDownList data={FontWhtValues} textField="n" dataItemKey="k" value={FontWhtValues.find(c => c.k === this.state.ItemNameFontWht)} name="ItemNameFontWht" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Sample</span>
                      <input value={this.state.ItemNameSample} name='ItemNameSample' onChange={evt => this.chgFldVal(evt)} className='ItemNameSampleCSS' />
                    </div>

                    <div style={{ height: '7px',minHeight: '7px' }}>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Description</span>
                      <div className='editDDPosL'>
                        <DropDownList data={FontTypeValues} textField="n" dataItemKey="k" value={FontTypeValues.find(c => c.k === this.state.ItemDescFontType)} name="ItemDescFontType" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVShort" />
                      </div>
                      <div className="editDDPosM">
                        <DropDownList data={FontSizeValues} textField="n" dataItemKey="k" value={FontSizeValues.find(c => c.k === this.state.ItemDescFontSize)} name="ItemDescFontSize" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                      <div className="editDDPosR">
                        <DropDownList data={FontWhtValues} textField="n" dataItemKey="k" value={FontWhtValues.find(c => c.k === this.state.ItemDescFontWht)} name="ItemDescFontWht" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Sample</span>
                      <input value={this.state.ItemDescSample} name='ItemDescSample' onChange={evt => this.chgFldVal(evt)} className='ItemDescSampleCSS' />
                    </div>

                    <div style={{ height: '78px',minHeight: '78px' }}>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Head Text</span>
                      <div className='editDDPosL'>
                        <DropDownList data={FontTypeValues} textField="n" dataItemKey="k" value={FontTypeValues.find(c => c.k === this.state.HeadFontType)} name="HeadFontType" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVShort" />
                      </div>
                      <div className="editDDPosM">
                        <DropDownList data={FontSizeValues} textField="n" dataItemKey="k" value={FontSizeValues.find(c => c.k === this.state.HeadFontSize)} name="HeadFontSize" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Sample</span>
                      <input value={this.state.HeadSample} name='HeadSample' onChange={evt => this.chgFldVal(evt)} className='HeadSampleCSS' />
                    </div>

                    <div style={{ height: '78px',minHeight: '78px' }}>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Section</span>
                      <div className='editDDPosL'>
                        <DropDownList data={FontTypeValues} textField="n" dataItemKey="k" value={FontTypeValues.find(c => c.k === this.state.SectionFontType)} name="SectionFontType" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVShort" />
                      </div>
                      <div className="editDDPosM">
                        <DropDownList data={FontSizeValues} textField="n" dataItemKey="k" value={FontSizeValues.find(c => c.k === this.state.SectionFontSize)} name="SectionFontSize" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Sample</span>
                      <input value={this.state.SectionSample} name='SectionSample' onChange={evt => this.chgFldVal(evt)} className='SectionSampleCSS' />
                    </div>
                    {/* --- For Future Use --
                      
                    <div style={{ height: '76px',minHeight: '76px' }}>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>List</span>
                      <div className='editDDPosL'>
                        <DropDownList data={FontTypeValues} textField="n" dataItemKey="k" value={FontTypeValues.find(c => c.k === this.state.ListFontType)} name="ListFontType" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVShort" />
                      </div>
                      <div className="editDDPosM">
                        <DropDownList data={FontSizeValues} textField="n" dataItemKey="k" value={FontSizeValues.find(c => c.k === this.state.ListFontSize)} name="ListFontSize" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Sample</span>
                      <input value={this.state.ListSample} name='ListSample' onChange={evt => this.chgFldVal(evt)} className='ListSampleCSS' />
                    </div> 

                    <div style={{ height: '7px',minHeight: '7px' }}>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Prompt</span>
                      <div className='editDDPosL'>
                        <DropDownList data={FontTypeValues} textField="n" dataItemKey="k" value={FontTypeValues.find(c => c.k === this.state.PromptFontType)} name="PromptFontType" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVShort" />
                      </div>
                      <div className="editDDPosM">
                        <DropDownList data={FontSizeValues} textField="n" dataItemKey="k" value={FontSizeValues.find(c => c.k === this.state.PromptFontSize)} name="PromptFontSize" onChange={evt => this.chgDDFldValKey(evt)} className="editInputDVExShort" />
                      </div>
                    </div>
                    <div id='div2' className='editField'>
                      <span className='editFieldLabel'>Sample</span>
                      <input value={this.state.Sample9Text} name='Sample9Text' onChange={evt => this.chgFldVal(evt)} className='sampleInput9' />
                    </div>

                    */}
                  </div>

                </div>

                <div className="editTabRightXNarrow">
                  {/*<div className='editTAField'>
                    <span className='editFieldLabel'>App Configuration</span>
                    <div className='editDDPos'>
                      <MultiSelect data={ApplicationConfigurationList} value={this.state.ApplicationConfigurationVals} name='ApplicationConfiguration' onChange={this.onChangeApplicationCnfg} className='editInputDD' />
                    </div>
                  </div>*/}
                  <h2>Configuration Control </h2>
                  <br />
                  <div id="div2" className="editField">
                    <Switch checked={this.state.ScanAndPay} name="ScanAndPay" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Scan And Pay</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.OrderAndPay} name="OrderAndPay" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Order And Pay</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.ScanPayIndividualItems} name="ScanPayIndividualItems" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Scan Pay Individual Items</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasIngredients} name="HasIngredients" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Ingredients</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasOrderToTable} name="HasOrderToTable" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Order To Table</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasDelivery} name="HasDelivery" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Delivery</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasTip} name="HasTip" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Tip</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasItemLookup} name="HasItemLookup" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Item Lookup</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasRecipeLookup} name="HasRecipeLookup" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Recipe Lookup</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasStorePromotion} name="HasStorePromotion" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Store Promotion</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasAccountInfo} name="HasAccountInfo" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Account Info</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasGiftCards} name="HasGiftCards" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Gift Cards</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasCoupons} name="HasCoupons" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Coupons</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasShoppingList} name="HasShoppingList" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Shopping List</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.CategoryPage} name="CategoryPage" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Category Page</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasPartialPayment} name="HasPartialPayment" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Partial Payment</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasSeats} name="HasSeats" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Seats</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasGuestInvite} name="HasGuestInvite" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Guest Invite</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasDiscounts} name="HasDiscounts" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Discounts</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasCredit} name="HasCredit" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Credit</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasReturns} name="HasReturns" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Returns</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasTax1} name="HasTax1" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Tax1</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasTax2} name="HasTax2" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Tax2</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasTax3} name="HasTax3" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Tax3</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasWorkflow} name="HasWorkflow" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Workflow</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasCashPayment} name="HasCashPayment" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Cash Payment</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasVoidOrder} name="HasVoidOrder" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Void Order</span>
                  </div>
                  <div id="div2" className="editField">
                    <Switch checked={this.state.HasVoidItem} name="HasVoidItem" onChange={evt => this.chgCheckboxVal(evt)} /><span className="editFieldLabel"> &nbsp; Has Void Item</span>
                  </div>
                </div>
              </TabStripTab>
              <TabStripTab title="Images">
                <div className="editTabLeftNarrow">
                  <div id="divI1" className="editInside">
                    <h3>Company Logo</h3>
                    <br />
                    <div className="framePic">
                      <Avatar rounded='large' size='large' type='image' className='avatarFramePic'>
                        <img src={this.state.CompanyLogoImageURL} height={280} width={360} style={{ objectFit: 'fill',}} />
                      </Avatar>
                    </div>
                    {/*<div className="framePicUpload">*/}
                    {/*  */}{/*<input type="file" style={{ marginLeft: '15px' }} onChange={this.onSelectImageFile} />*/}
                    {/*  <ExternalDropZone*/}
                    {/*    uploadRef={uploadCompanyRef}*/}
                    {/*    customHint={<span>Drop the Company Logo Image Here</span>}*/}
                    {/*    customNote={<span>The Image should have an aspect ratio of 4:3</span>}*/}
                    {/*    style={{*/}
                    {/*      backgroundColor: "antiquewhite", height: "10px", width: "370px"*/}
                    {/*    }}*/}
                    {/*  />*/}
                    <div style={{ position: "relative",top: "0px",width: "370px",border: "solid 2px grey" }}>
                      <Upload
                        ref={uploadCompanyRef}
                        batch={false}
                        multiple={true}
                        files={this.state.files}
                        onAdd={this.addCompanyLogoImage}
                        onRemove={this.onRemove}
                        onStatusChange={this.onStatusChange}
                        saveUrl={null}
                        defaultFiles={[]}
                        withCredentials={false}
                      />
                    </div>
                  </div>
                </div>
                <div id="divI2" className="frameSecondPic">
                  {/*<div className="editTabMiddle">*/}
                  <div id="div1" className="editInside">
                    <h3>Brand Logo</h3>
                    <br />
                    <div className="framePic">
                      <Avatar rounded='large' size='large' type='image' className='avatarFramePic'>
                        <img src={this.state.BrandLogoImageURL} height={280} width={360} style={{ objectFit: 'fill',}} />
                      </Avatar>
                    </div>
                    <div className="framePicUpload">
                      {/*  <ExternalDropZone*/}
                      {/*    uploadRef={uploadBrandRef}*/}
                      {/*    customHint={<span>Drop the Company Brand Image Here</span>}*/}
                      {/*    customNote={<span>The Image should have an aspect ratio of 4:3</span>}*/}
                      {/*    style={{*/}
                      {/*      backgroundColor: "antiquewhite", height: "10px", width: "370px"*/}
                      {/*    }}*/}
                      {/*/>*/}
                      <div style={{ position: "relative",top: "0px",width: "370px",border: "solid 2px grey" }}>
                        <Upload
                          ref={uploadBrandRef}
                          batch={false}
                          multiple={true}
                          files={this.state.files}
                          onAdd={this.addBrandLogoImage}
                          onRemove={this.onRemove}
                          onStatusChange={this.onStatusChange}
                          saveUrl={null}
                          defaultFiles={[]}
                          withCredentials={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="editTabMiddle">
                  <div id="divI1" className="editInside">
                    <h3>Company Image</h3>
                    <br />
                    <div className="framePic">
                      <Avatar rounded='large' size='large' type='image' className='avatarFramePic'>
                        <img src={this.state.CompanyImageURL} height={280} width={360} style={{ objectFit: 'fill',}} />
                      </Avatar>
                    </div>
                    <div className="framePicUpload">
                      <div style={{ position: "relative",top: "0px",width: "370px",border: "solid 2px grey" }}>
                        <Upload
                          ref={uploadCompanyImageRef}
                          batch={false}
                          multiple={true}
                          files={this.state.files}
                          onAdd={this.addCompanyImage}
                          onRemove={this.onRemove}
                          onStatusChange={this.onStatusChange}
                          saveUrl={null}
                          defaultFiles={[]}
                          withCredentials={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="editTabRightNarrow">
                  <div id="div1" className="editInside">
                    <h3>Menu Background Image</h3>
                    <div className="framePicLong">
                      <Avatar rounded='large' size='large' type='image' className='avatarLongFrame'>
                        <img src={this.state.BackgroundImageURL} height={600} width={370} style={{ objectFit: 'fill',}} />
                      </Avatar>
                    </div>
                    <div className="framePicUpload">
                      <div style={{ position: "relative",top: "0px",width: "370px",border: "solid 2px grey" }}>
                        <Upload
                          ref={uploadBGRef}
                          batch={false}
                          multiple={true}
                          files={this.state.files}
                          onAdd={this.addBackgroundImage}
                          onRemove={this.onRemove}
                          onStatusChange={this.onStatusChange}
                          saveUrl={null}
                          defaultFiles={[]}
                          withCredentials={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </TabStripTab>
              <TabStripTab title="View Menu App">
                <Iframe src={this.subInteract} height={SessionInfo.Height - 150} width="750" style={{ border: "solid 3px blue",borderRadius: "5px" }} /> {/*className="iFrame" />*/}
              </TabStripTab>
            </TabStrip>
          </div>
          <Popup offset={this.helpListPopupOffset} show={this.state.showHelpListPopup} popupClass={'popupHelp'} >
            <div id="helpBox">
              <div className="helpList">
                <ListView data={this.state.HelpPages} item={this.HelpPageFormat} header={this.HelpPageHeader} footer={this.HelpPageFooter} />
              </div>
              <br />
            </div>
          </Popup>
          <Popup offset={this.helpDetailOffset} show={this.state.showHelpDetail} popupClass={'popupHelpDetail'} onClick={this.closeHelpTime}>
            <div className="frameInfo" id="notifyBoxPU" dangerouslySetInnerHTML={{ __html: this.state.helpDetail }} onClick={this.closeHelpTime}></div>
          </Popup>
        </div>
        {
          SessionInfo.displayFooter === true ?
            <PageFooter L1='Home' IsApp='y' /> : null
        }
      </div>
    );
  }
}

export default withRouter(SettinsPage)